<!--
 * @Author:
 * @Description: 模型加载与基本功能
-->
<template>
  <div class="w-full h-full position-relative" v-loading="loadingEngine">
    <slot></slot>
    <img :id="playerEngineDomId" class="engineImg w-full" v-if="isImg" />
    <video
      v-else
      :id="playerEngineDomId"
      autoplay
      playsinline
      muted
      class="engineVideo w-full"
    ></video>
    <!-- 工具栏 -->
    <div class="position-absolute flex-row-center-center b-40 w-full ml-20px mr-20px">
      <tab-bar
        :id="basicTabBarId"
        :style="{ width: `${basicTabBar.length * 44 + 10}px` }"
        direction="bottom"
        :tabBarId="basicTabBarId"
        :disable="basicTabBarDisable"
        :tags="basicTabBar"
        :selectTagList="selectBasicList"
        :activeTag="currentBasicCom ? currentBasicCom.val : ''"
        @tagsClick="tagsClick"
      ></tab-bar>
    </div>
    <!-- 业务组件弹框 -->
    <DialogTabBar
      :top="basicTop"
      :currentCom="showBasicComponents"
      :dialogList="openDialogList"
      @switchDialog="switchDialog"
      v-if="showBasicDialog"
    ></DialogTabBar>
    <keep-alive :include="keepAliveList.join(',')">
      <component
        v-if="showBasicDialog"
        :is="showBasicComponents"
        :key="showBasicComponents"
        :player="player"
        :height="basicHeight"
        :top="basicTop"
        :modelName="modelName"
        :currentItem="currentItem"
        :modelTreeProp="modelTreeProp"
        :currentFileId="currentFileId"
        :clipData="clipData"
        :defaultSettings="defaultSettings"
        :currentCreateNode="currentCreateNode"
        :currentEditMoment="currentEditMoment"
        :cloudRender="cloudRender"
        @closeComponents="closeComponents"
        @setModelVisible="setModelVisible"
        @handleNodeClick="handleNodeClick"
        @modifyNodeEnd="modifyNodeEnd"
        @currentCodeChange="currentCodeChange"
      ></component>
    </keep-alive>
    <!-- 模型进度条 -->
    <player-progress
      :loadType="loadType"
      :percentage="loadPercentage"
      v-if="showLoadProgress"
    ></player-progress>
    <!-- 圆形按钮框组件 -->
    <circle-menu
      v-if="isShowCircleMenu"
      :dialogWidth="iframeW"
      :dialogTitle="dialogTitle"
      @sendCurrentType="handleOpen"
      @handleClose="handleClose"
    >
      <!-- 弹框组件 -->
      <component
        :is="showComponents"
        v-if="isShowDialog"
        ref="componentsRef"
        :currentType="currentType"
        :nowTime="nowTime"
      ></component>
    </circle-menu>
    <!-- 右键菜单 -->
    <right-click-menu
      v-if="!loadingEngine && !_.isNil(player)"
      :tags="basicTabBar"
      :player="player"
      :selectBasicList="selectBasicList"
      @tagsClick="tagsClick"
      @moveCamera="moveCamera"
      @setModelVisible="setModelVisible"
    ></right-click-menu>
    <LocalForageView
      :visible.sync="isShowLocalForageView"
      v-if="isShowLocalForageView"
      @restoreLocalView="restoreLocalView"
    >
    </LocalForageView>
  </div>
</template>
<script>
import ConfirmAuth from '@/assets/js/confirmAuth'
import { resetObjectValue } from '@/assets/js/commonUtil'
import DocumentService from '@/services/DocumentService'
import DocumentManagementService from '@/services/documentManagement'
import PreloadService from '@/services/PreloadService'
import { debounce } from 'lodash'
// 多功能圆形按钮弹框组件集合(蒙东售前)
import { PreferenceSettingApi } from '@/services/cloud-render-management'
import CircleMenu from '@/views/mdPowerGrid/preSales/circleMenu'
import RealMonitoring from '@/views/mdPowerGrid/preSales/multifunctionDialog/realMonitoring'
import VideoCamera from '@/views/mdPowerGrid/preSales/multifunctionDialog/videoCamera'
import WarnningsList from '@/views/mdPowerGrid/preSales/multifunctionDialog/warnningsList'
import OtherInfo from '@/views/mdPowerGrid/preSales/multifunctionDialog/OtherInfo'
import FaultLibrary from '@/views/mdPowerGrid/preSales/multifunctionDialog/FaultLibrary'
import { loadSceneFromJson, getNodesByNodeType } from '@/views/documentBrowse/js/engineerSceneData'
import { restore } from './js/calcOffset'
import { cilpSetting, cancelClip } from './js/clip'
import { multipleLocations, findTower, modelTreeObj, addBoardNode } from './js/publicModelMays'
import { download3dFile, download3dFileVk } from './js/download3dFile'

const DialogTabBar = () => {
  return import('./DialogTabBar')
}
const PlayerProgress = () => {
  return import('./PlayerProgress')
}
const tabBar = () => {
  return import('./TabBar')
}
// 弹框组件
const ClipTool = () => {
  return import('./dialog/ClipToolVk')
}
// 地下开挖
const UndergroundClip = () => {
  return import('./dialog/UnderClip')
}
const ModelTree = () => {
  return import('./dialog/ModelTreeDialogVk')
}
// 用户偏好设置
const PreferenceSetting = () => {
  return import('./dialog/PreferenceSetting')
}
// 材质编辑
const EditTexture = () => {
  return import('./dialog/EditTextureVk')
}
// 模型透明度
const transparencySetting = () => {
  return import('./dialog/transparencySetting')
}
// 右键菜单
const rightClickMenu = () => {
  return import('./dialog/RightClickMenu')
}
// 模型节点编辑树
const NodeEditTree = () => {
  return import('./dialog/NodeEditTree')
}
// 本地存储视角弹窗
const LocalForageView = () => {
  return import('./dialog/LocalForageView')
}
// 电缆清单
// const CableList = () => {
//   return import('./dialog/CableList')
// }
export default {
  components: {
    tabBar,
    ModelTree,
    PlayerProgress,
    PreferenceSetting,
    AllClip: ClipTool,
    PartClipBox: ClipTool,
    ThreePanel: ClipTool,
    UndergroundClip,
    EditTexture,
    transparencySetting,
    DialogTabBar,
    CircleMenu,
    RealMonitoring,
    VideoCamera,
    WarnningsList,
    OtherInfo,
    FaultLibrary,
    rightClickMenu,
    NodeEditTree,
    LocalForageView,
    // CableList,
  },
  props: {
    /**
     * @description: 模型加载相关
     * @param {*}
     * @return {*}
     */
    modelParams: {
      type: Array,
      default: () => {
        return []
      },
    },
    cloudRender: {
      type: Object,
      default: () => {},
    },
    // 当前选中的位号code
    code: {
      type: String,
      default: '',
    },
    // 当前选中模型的模型名称
    modelName: {
      type: String,
      default: '',
    },
    // code变化是由什么触发的
    codeChangeType: {
      type: String,
      default: '',
    },
    gisAttrKeys: {
      type: Array,
      default: () => {
        return []
      },
    },
    modelProps: {
      type: Object,
      default: () => {
        return {
          defaultModelId: '', // 模型都加载完成后，默认定位的那个模型
          sceneOpenType: '', // 当前场景类型，是否加载地球文件 0是有地球文件，1是没有地球文件，''代表从模型中心过来
        }
      },
    },
    // 基础的tabBar
    basicTabBar: {
      type: Array,
      default: null,
    },
    // 业务的tabBar
    businessTabBar: {
      type: Array,
      default: null,
    },
    showDocComponent: {
      type: Boolean,
      default: false,
    },
    docHeight: {
      type: Object,
      default: () => {
        return {
          minHeight: '30rem',
          tmaxHeight: '40rem',
          isZoom: false,
        }
      },
    },
    businessTabInfo: {
      type: Object,
      default: () => {
        return {
          selectBusinessList: '',
          currentDialog: '',
        }
      },
    },
    // 是否显示系统设置
    showPlayerSysSetting: {
      type: Boolean,
      defalut: false,
    },
    // 新增加的模型节点
    currentCreateNode: {
      type: Number,
      default: 0,
    },
    // 每次执行节点编辑的时间
    currentEditMoment: {
      type: Number,
      default: 0,
    },
    playerEngineId: {
      type: String,
      defalut: 'engineId',
    },
    showCloseScreen: {
      type: Boolean,
      defalut: false,
    },
  },
  computed: {
    isImg() {
      return Wiz.globalSettings.globalConfig.modelSetting.cloudRenderLoadMode === 'img'
    },
    fullToken() {
      return localStorage.getItem('localforage/fullToken')
    },
    cloundProtocol() {
      // 云渲染协议
      const obj = _.find(this.systemParams, { parameterCode: 'cloundProtocol' })
      return obj ? obj.parameterValue : 'ws'
    },
    cloundServerPath() {
      // 云渲染服务路径
      const obj = _.find(this.systemParams, { parameterCode: 'cloundServerPath' })
      return obj ? obj.parameterValue : '192.168.20.71:8082'
    },
    currentProject() {
      return this.$store.getters.currentProject || {}
    },
    globalMapPath() {
      // 地图路径
      const obj = _.find(this.systemParams, { parameterCode: 'globalMapPath' })
      return obj ? obj.parameterValue : ''
    },
    basicTop() {
      return this.docHeight.isZoom ? `${parseInt(this.docHeight.minHeight) + 4.6}rem` : '6.6rem'
    },
    modelAnimationSuffix() {
      // 模型关联动画文件的后缀名
      const version = _.find(this.systemParams, { parameterCode: 'modelAnimationSuffix' }) || {}
      return version.parameterValue
    },
    classId() {
      return this.$route.query.classId
    },
    isVersion() {
      return this.$route.query.isVersion
    },
  },
  data() {
    return {
      currentEnv: Wiz.GetModuleConfig('legacy-resource').currentEnv,
      systemParams: localStorage.getItem('systemParams')
        ? JSON.parse(localStorage.getItem('systemParams'))
        : [],
      playerEngineDomId: 'engineId',
      businessTabBarComputed: [],
      moduleAuth: {}, // 页面操作权限
      keepAliveList: [],
      // 模型相关数据 start
      player: null, // player实例化对象
      ModelMapList: [], // 模型映射列表
      demPlayerId: '', // 模型附件的md5
      loadingEngine: false, // 引擎加载状态
      isShowLocalForageView: false,
      curModelSerialNum: 0, // 当前正在加载的模型序号
      currentModelInfo: {}, // 当前正在加载的模型信息
      curModelList: [],
      taskId: null, // 加载任务id
      GisLoaded: false, // 是否已经加载GIS
      preloadEngineId: '', // 预加载引擎Id
      // 进度相关信息
      loadPercentage: 0,
      showLoadProgress: false,
      loadType: '下载中...',
      // 模型树相关
      isLoadGis: 0,
      LLH: [], // 当前模型经纬高
      noSwitchModel: true, // 未切换过模型
      modelTreeProp: {
        currentNodeItem: 0, // 当前激活的node
        currentNodeName: '', // 点选时当前激活的节点名称
        treeData: [], // 模型树数据
        defaultCheckedKey: [], // 模型树选中的节点
        filterItem: [], // 模型树不需要显示的节点及他的父节点列表
        modelHideList: [], // 模型隐藏队列
        modelTreeLoadEnd: false, // 模型树数据加载完毕
        loadModelStatus: false,
      },
      spaceSwapStatus: false, // 交换空间状态
      addModelNum: 0, // 当前加载模型的数量
      // 模型相关数据 end

      // 弹框相关 start
      showBasicComponents: '',
      showBasicDialog: false,
      // 当前激活的弹框信息
      currentBasicCom: {
        name: '',
        val: '',
        iconName: '',
        activeIconName: '',
      },
      basicHeight: '',
      // 剖切相关数据
      clipData: {
        clipType: '', // 剖切方式
        axisObjs: [], // 剖切轴对象
        clipObj: {}, // 全局剖切对象
      },
      // 弹框相关 end

      activeBasicTag: '',
      lastActiveBasicTag: '', // 上一次激活的基础功能
      activeBusinessTag: '',
      selectBasicList: [], // 选中的基础list
      centerCode: '',
      currentItem: 0, // 当前的节点item
      currentNode: 0, // 当前节点
      openDialogList: [],
      basicTabBarDisable: false,

      // 工具类，不需要清除状态的
      toolTabBar: [
        'system.Move',
        'system.Rotate',
        'system.ToolFixedObservation',
        'system.Scale',
        'system.PickupCenter',
        // 'system.ToolMLine', // 测量单独处理
        // 'system.ToolMPoint',
        // 'system.ToolVertical',
        // 'system.Toolp2p',
        // 'system.ToolAngle',
        // 'system.ToolArea',
        // 'system.ToolWheelBase',
        'system.Pickup',
        'system.walk.first',
        'system.walk.third',
      ],
      // 需要展示弹框的节点
      showDialogCom: [
        'ModelTree',
        'PreferenceSetting',
        'AllClip',
        'PartClipBox',
        'ThreePanel',
        'EditTexture',
        'transparencySetting',
        'NodeEditTree',
        'UndergroundClip',
        // 'CableList',
      ],
      // 剖切相关的组件
      clipCom: ['AllClip', 'PartClipBox', 'ThreePanel'],
      // 漫游相关
      roamCom: ['system.walk.first', 'system.walk.third'],
      physicsSceneUpdated: false, // 是否已经更新物理场景
      // 当前激活的工具队列
      activeBasicToolList: [],
      mixerObj: null, // 混合器对象
      currentFileId: '', // 当前pr文件的fileId
      anchorMarkerId: null, // 锚点信息框标记
      // 圆形工具按钮的数据集合
      iframeW: '1100px', // 弹框iframe内嵌的宽度
      showComponents: 'VideoCamera', // 工具菜单的当前显示的弹框组件
      isShowDialog: true, // 工具菜单的当前显示的弹框组件是否显示
      dialogTitle: '', // 当前要覆盖弹框title的title
      currentType: '', // 当前弹框类型
      nowTime: '', // 系统当前时间
      nowTimer: null,
      isShowCircleMenu: false,
      towerNodePtrs: [], // 杆塔指针对象映射关系表
      userPreferenceSettings: {}, // 用户偏好设置
      defaultSettings: {}, // player默认设置
      engineerSceneData: {}, // 工程场景数据
      engineerSceneFileList: [], // 工程数据中文件列表
      engineerFileCount: 0, // 工程数据中文件数量
      curBytesTotal: null, // 当前下载pr文件的大小
      reconnect: false, // 当前是否再在尝试重新连接player
      reconnectTimer: null, // 重连的计时器
      reconnectTime: 0, // 重连次数（对应了初始化player中的maxTimeout）
      fileId: '',
      triggerType: '',
    }
  },
  watch: {
    modelTreeProp: {
      immediate: true,
      deep: true,
      handler(val) {
        this.$emit('updateModelTreeProp', val)
      },
    },
    '$route.query.isSpecailFrom': function(newVal) {
      this.isShowCircleMenu = newVal
    },
    businessTabBar: {
      // 解决部分地方，有配置菜单的权限，及时去更新按钮
      handler(val) {
        this.businessTabBarComputed = this.businessTabBar
        this.tabBarResize()
      },
      immediate: true,
    },
    showCloseScreen() {
      this.businessTabBarComputed = this.businessTabBar
      this.tabBarResize()
    },
    // 监听工程数据中文件已校验的数量
    async engineerFileCount(val) {
      if (val === 0) {
        return
      }
      if (val >= this.engineerSceneFileList.length) {
        await this.loadEngineerData()
        this.engineerFileCount = 0
      } else {
        this.getFileIsExist(this.engineerSceneFileList[val])
      }
    },
    showBasicComponents(val) {
      this.$emit('sendBasicComponents', val)
    },
    modelParams: {
      deep: true,
      handler(val) {
        this.switchModel(val[0].documentId)
      },
    },
    code: debounce(function(code) {
      if (code && this.player && this.codeChangeType !== `pickUp${this.playerEngineDomId}`) {
        this.$nextTick(() => {
          this.moveCamera(code, this.codeChangeType)
        })
      }
    }, 500),
    modelName(val) {
      // 只有场景切换模型时是直接定位
      if (val && this.player && this.$route.query.sceneId) {
        this.$nextTick(() => {
          this.moveBymodelName(val)
        })
      }
    },
    // async addModelNum(val) { // 待定删除
    //   if (val === this.modelParams.length) {
    //     this.moveBymodelName(this.modelProps.defaultModelId) // 定位到默认模型
    //     this.$emit('LoadedAllModel')
    //     this.getModelTreeDatas()
    //     this.modelTreeProp.modelTreeLoadEnd = true
    //   }
    // },
    showDocComponent(bol) {
      console.log(bol, 'bol-11')
      this.basicHeight = bol ? this.currentBasicCom.minHeight : this.currentBasicCom.maxHeight
      if (this.showBasicComponents && bol) {
        const val = parseInt('53rem') - parseInt(this.basicHeight)
        this.docHeight.minHeight = `${val}rem`
        this.docHeight.maxHeight = `${val}rem`
        this.docHeight.isZoom = true
        // 清除弹框状态，菜单栏状态
        this.showBasicDialog = true
        this.currentBasicCom = ''
        this.showBasicComponents = ''
        this.docHeight.minHeight = '30rem'
        this.docHeight.maxHeight = '40rem'
        this.docHeight.isZoom = false
      } else {
        this.docHeight.minHeight = '30rem'
        this.docHeight.maxHeight = '40rem'
        this.docHeight.isZoom = false
      }
    },
    // 系统设置显隐
    showPlayerSysSetting(val) {
      this.$nextTick(async () => {
        // 获取player默认显示设置
        const jsonData = await this.player.Native.Settings.loadJsonString(
          `data://../apps/${this.currentEnv.VUE_APP_CURRENT_PROJECT}/settings.json`
        )
        if (jsonData) {
          this.defaultSettings = JSON.parse(jsonData)
        } else {
          this.defaultSettings.Show = await this.player.Native.Settings.getAll()
          this.defaultSettings.RoamTrance = await this.player.Native.Walking.getHotkeys()
          this.defaultSettings.Skin = {
            avatarCapSkin: 'helmet_white.jpg',
            avatarBodySkin: 'GongRen_red.jpg',
          }
        }
        if (!val) {
          // 获取用户偏好设置
          this.setPreferenceSettings()
        } else {
          if (this.selectBasicList.includes('PreferenceSetting')) {
            this.closeComponents('PreferenceSetting')
            this.selectBasicList.splice(this.selectBasicList.indexOf('PreferenceSetting'), 1)
          }
          _.forEach(this.defaultSettings.Show, (item) => {
            this.player.Native.Settings.set(item.name, item.type, item.value)
          })
          _.forIn(this.defaultSettings.RoamTrance, (value, key) => {
            const settingKeys = _.reduce(
              value,
              (arr, item) => {
                arr.push(item.split('+'))
                return arr
              },
              []
            )
            this.player.Native.Walking.setHotkey(key, settingKeys)
          })
          const isExists = await this.player.Native.File.exists(
            `data://../apps/${this.currentEnv.VUE_APP_CURRENT_PROJECT}/skin`
          )
          if (isExists) {
            this.player.Native.Walking.setAvatarBodySkin(
              `data://../apps/${this.currentEnv.VUE_APP_CURRENT_PROJECT}/skin/${this.defaultSettings.Skin.avatarBodySkin}`
            )
            this.player.Native.Walking.setAvatarCapSkin(
              `data://../apps/${this.currentEnv.VUE_APP_CURRENT_PROJECT}/skin/${this.defaultSettings.Skin.avatarCapSkin}`
            )
          }
        }
      })
    },
  },
  methods: {
    // 模型节点编辑完成
    modifyNodeEnd(timing, node) {
      this.$emit('modifyNodeEnd', timing, node)
    },
    addBoard(item) {
      this.player.Native.File.getFileMd5(
        `data://../apps/${this.currentEnv.VUE_APP_CURRENT_PROJECT}/models/${item.md5}/${item.md5}.pr`,
        async (res) => {
          if (res === item.md5) {
            // 有模型就加载模型
            await addBoardNode(
              item.merchantId,
              `data://../apps/${this.currentEnv.VUE_APP_CURRENT_PROJECT}/models/${item.md5}/${item.md5}.pr`,
              item,
              this.player,
              this.checkModelLoad,
              this.checkModelLoadEnd,
              this.fullToken
            )
            this.addModelNum += 1
          } else {
            // 校验md5失败
            this.downloadFile(item.md5, 'node', item)
          }
        }
      )
    },
    // 关闭弹框操作
    handleClose() {
      switch (this.currentType) {
        case 'fa-video-camera':
          clearInterval(this.nowTimer)
          this.nowTimer = null
          break
        default:
          console.log('nothing')
          break
      }
    },
    // 打开弹框操作
    async handleOpen(val) {
      this.currentType = val.iconName
      this.showComponents = val.componentName
      this.dialogTitle = ''
      this.isShowDialog = true
      this.iframeW = '1100px'
      switch (val.iconName) {
        case 'fa-video-camera':
          this.nowTimer = setInterval(this.getNowTime, 1000)
          break
        default:
          console.log('nothing')
          break
      }
    },
    // 获取当前时间 监控时间效果
    getNowTime() {
      const date = new Date()
      this.nowTime = date.toLocaleString()
    },
    /**
     * @description: 模型切换
     * @param {*}
     * @return {*}
     */

    async switchModel(mixerName) {
      // 清除模型选择状态
      this.$emit('loadingSwitch', { bol: true, title: '模型切换中，请勿操作' })
      this.removeModelStatus()
      // this.addModelNum = 0
      this.curModelSerialNum = 0
      this.noSwitchModel = false
      if (!_.isEmpty(this.player)) {
        // 卸载地球重新加载
        await this.player.Native.GisPlatform.unloadMap()
        this.GisLoaded = false
        this.isLoadGis = 0
        this.LLH = [] // 当前模型经纬高
        // 卸载模型
        if (this.curModelList.length) {
          const nodes = _.map(this.curModelList, 'node')
          await this.player.Native.Node.destroy(nodes)
          this.curModelList = this.$options.data().curModelList
          this.curModelSerialNum = 0
        } else if (this.preloadEngineId) {
          // 如果是预加载，直接卸载根节点
          const rootNode = await this.player.Native.Node.getRoot()
          const tempNodeInfo = await this.player.Native.Node.getProperty(rootNode, ['children'])
          this.player.Native.Node.destroy([tempNodeInfo.children[0].node])
        }
        this.modelTreeProp.loadModelStatus = false
        // 卸载之后重回主视角，否则加载模型倾斜
        await this.player.Native.Camera.goHome(0.2)
        // this.player.Native.Model.EventProgress.connect(this.checkModelLoad)
        // this.player.Native.Model.EventProgressEnd.connect(this.checkModelLoadEnd)
        setTimeout(async () => {
          await this.gisLoad()
          console.log('checkModel')
          this.checkModel()
        }, 500)
      } else {
        this.$nextTick(() => {
          this.runPlayer(mixerName)
        })
      }
    },
    removeModelStatus() {
      this.removeTagsStatus(this.selectBasicList, true)
      this.selectBasicList = []
    },
    // 模型加载相关 start
    // 生成uuid
    generateUUID() {
      let d = new Date().getTime()
      if (this.performance && typeof this.performance.now === 'function') {
        d += performance.now()
      }
      const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (d + Math.random() * 16) % 16 | 0
        d = Math.floor(d / 16)
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
      })
      return uuid
    },
    /**
     * @description: 加载引擎
     * @param {*}
     * @return {*}
     */
    async runPlayer(mixerName) {
      try {
        const uuid = this.generateUUID()
        const cloundServerPath = `${Wiz.globalSettings.globalConfig.modelSetting.cloudProtocol}://${Wiz.globalSettings.globalConfig.modelSetting.cloudServerPathVulkan}`
        const param = {
          signalServer: cloundServerPath, // 信令服务器地址(player给提供都是ws)
          options: {
            videoDom: document.getElementById(this.playerEngineDomId), // 绑定视频标签
            userTimeout: 1000 * 60 * 60, // 用户操作超时设置，毫秒
            engineId: this.preloadEngineId || uuid, // 要连接的引擎ID
            exitTimeout: 1000 * 60, // 用户超时后多久断开会话
            maxTimeout: 1000, // 会话超时时间，允许掉线后引擎保存多久，在该时间内可重新连接到会话，否则会创建新的会话
            // openDebug: true,
          },
        }
        const { data } = await this.cloudRender.Engine.loadEngine(param)
        console.log(this.cloudRender, 'cloudRender-11')
        // this.cloudRender.Engine.setPixelRatio(2.5)
        console.log(data, 'engineData')
        this.player = data.getDataInfo()
        console.log(this.player, 'player-22')
        this.cloudRender.Dispatch.on('Engine', this.engineMessage)
        // 监听实例化完成后
        window.player = this.player
        this.initPlayer()
      } catch (error) {
        console.log(error, 'error')
        this.$emit('loadingSwitch', { bol: false, title: error })
        this.$emit('loadError', error)
      }
    },
    engineMessage(e) {
      if (e.type === 'UserTimeOut') {
        // 用户操作超时
        console.error('用户操作超时')
      }
      if (e.type === 'TimeOutExit') {
        // 断开会话
        console.error('超时断开')
      }
    },
    async initPlayer() {
      // 实例化完成将实例化后的player传出去
      this.$emit('sendPlayer', this.player)
      this.loadingEngine = false
      // 自动更新画面
      const autoRes = await this.cloudRender.Setting.set({
        name: 'sys.autoUpdateFrame',
        type: 'bool',
        value: false,
      })
      // 隐藏触屏快捷工具
      await this.player.Native.Setting.set('func.shortcutVisible', false)
      const settingsFileUrl = `data://../apps/${this.currentEnv.VUE_APP_CURRENT_PROJECT}/settings.json`
      const settingsData = await this.player.Native.File.loadText(settingsFileUrl)
      if (settingsData) {
        const defaultSettings = JSON.parse(settingsData)
        try {
          const res = await this.cloudRender.Setting.set(defaultSettings.Show)
        } catch (error) {
          console.error(error)
        }
      } else {
        // this.defaultSettings.Show = await this.player.Native.Settings.getAll() // 暂不处理
        // this.defaultSettings.RoamTrance = await this.player.Native.Walking.getHotkeys()
        this.defaultSettings.Skin = {
          avatarCapSkin: 'helmet_white.jpg',
          avatarBodySkin: 'GongRen_red.jpg',
        }
      }
      //  GIS模式下浏览时，设置启用/禁用摄像机地形碰撞,默认为启用状态 摄像机可进入到地形之下
      // this.player.Native.GisPlatform.setCameraTerrainCollisionEnabled(false) // Gis相关先不更改
      // if (jsonData) {
      //   this.defaultSettings = JSON.parse(jsonData)
      //   this.setPreferenceSettings()
      // } else {
      //   this.defaultSettings.Show = await this.player.Native.Settings.getAll()
      //   // this.defaultSettings.RoamTrance = await this.player.Native.Walking.getHotkeys() // 暂不处理
      //   this.defaultSettings.Skin = {
      //     avatarCapSkin: 'helmet_white.jpg',
      //     avatarBodySkin: 'GongRen_red.jpg',
      //   }
      // }
      // 获取用户偏好设置
      // this.getPreferenceSettings()
      // 获取到经纬度添加地图
      // this.isAddLoadMap(() => {
      //   this.player.Native.GisPlatform.loadMap(this.globalMapPath)  // Gis暂不处理
      // })
      // 点选监听(仅监听点选选中)
      this.player.Native.OperatingMode.EventPickUpNode.connect(this.pickupWatch)
      // this.player.Native.ModelTree.EventSelectItemChanged.connect(this.watchMsg) // 暂不处理
      // this.player.Native.ModelTree.EventBrowseLClick.connect(this.browseLClick)

      // 场景中心过来的
      // if (String(this.modelProps.sceneOpenType)) { // 场景暂不处理
      //   // 清空动画片段
      //   this.player.Native.AnimationClip.clearClip()
      //   // 创建混合器
      //   this.mixerObj = await PlayerUtils.call(
      //     this.player.Native.AnimationMixer.getMixer,
      //     mixerName
      //   )
      // }
      await this.gisLoad()
      if (this.preloadEngineId) {
        await this.locateModel(this.LLH, {}) // 设置模型位置
        this.currentFileId = this.modelParams[0].fileId
        this.modelTreeProp.loadModelStatus = true
        this.$emit('LoadedAllModel')
        // 定位到模型
        console.log('预加载定位')
        if (this.modelParams[0].CameraPosition) {
          console.log('默认视角定位')
          // 有默认视角通过默认视角定位
          const { eye, target, up } = JSON.parse(this.modelParams[0].CameraPosition)
          console.log('eye, target, up', eye, target, up)
          this.player.Native.Camera.addMoveTo(eye, target, up, 2)
        } else if (this.GisLoaded && this.LLH?.length) {
          console.log('经纬度定位')
          await this.player.Native.Camera.moveToLLH([this.LLH[0], this.LLH[1], 2000], 5)
        } else if (curModelInfo.node) {
          // 无默认视角通过模型节点定位
          console.log('通过node定位')
          await this.player.Native.Camera.moveToNode(curModelInfo.node, 2, 25)
        }
        return
      }
      if (this.$route.query.engineerId) {
        // this.loadByEngineer() // 工程中心 ？
      } else {
        this.checkModel() // 检查模型是否存在
      }
    },
    async getGisAttrInfoByDataId() {
      const res = await DocumentManagementService.getDynamicTableData({
        classId: this.$route.query.classId,
        dataId: this.modelParams[0].documentId,
      })
      if (res?.code === 0 && res.data) {
        if (this.gisAttrKeys?.length) {
          this.isLoadGis = res.data[this.gisAttrKeys[0]] || 0
          if (this.gisAttrKeys[1] && res.data[this.gisAttrKeys[1]]) {
            this.LLH = JSON.parse(res.data[this.gisAttrKeys[1]])
          } else {
            this.LLH = []
          }
        } else {
          this.isLoadGis = 0
          this.LLH = []
          this.$message.warning('无标准属性key')
        }
      }
    },
    async gisLoad() {
      if (this.playerEngineId === 'splitEngineId') {
        // 分屏不加地球
        this.isLoadGis = 0
        this.LLH = []
        return
      }
      if (this.$route.query.classId) {
        await this.getGisAttrInfoByDataId()
      }
      // gisAttrKeys
      // 是否需要加载Gis
      const GisMap = Wiz.globalSettings.globalConfig.modelSetting.globalMapPath || ''
      if (this.isLoadGis && GisMap) {
        await this.player.Native.GisPlatform.loadMap(GisMap)
        this.GisLoaded = true
      } else if (this.isLoadGis && !GisMap) {
        this.$message.error('GIS配置不存在')
      }
    },
    // 从工程中心进来加载场景
    // async loadByEngineer() {
    //   const res = await DocumentManagementService.getSceneJsonData({
    //     id: this.$route.query.engineerId,
    //   })
    //   if (res && res.code === 0 && res.data && res.data.treeJson) {
    //     this.engineerSceneData = JSON.parse(res.data.treeJson)
    //     this.engineerSceneFileList = await getNodesByNodeType(this.engineerSceneData)
    //     if (!_.isEmpty(this.engineerSceneFileList)) {
    //       this.getFileIsExist(this.engineerSceneFileList[0])
    //     } else {
    //       this.createEngineerRoot()
    //     }
    //   } else {
    //     this.createEngineerRoot()
    //   }
    // },
    // 创建根节点
    async createEngineerRoot() {
      const engineerRootNode = await this.player.Native.NodeProxy.createNode(
        0,
        this.$route.query.engineerName
      )
      this.player.Native.NodeProxy.setNodeInfo(engineerRootNode, {
        code: JSON.stringify({
          type: 'Root',
          fileType: '',
          filePath: '',
          documentId: this.$route.query.engineerId,
        }),
      })
    },
    // 判断文件是否存在
    // async getFileIsExist(data) {
    //   if (data.code && data.code.filePath) {
    //     const isExist = await this.player.Native.File.exists(data.code.filePath)
    //     const result = await this.player.Native.File.getFileMd5(
    //       `data://../apps/${this.currentEnv.VUE_APP_CURRENT_PROJECT}/models/${data.code.md5}/${data.code.md5}${data.code.fileType}`
    //     )
    //     if (isExist && result === data.code.md5) {
    //       this.engineerFileCount += 1
    //     } else {
    //       this.downloadEngineerFile(
    //         data.code.filePath,
    //         data.code.documentId,
    //         data.code.md5,
    //         data.code.materialFileMd5
    //       )
    //     }
    //   }
    // },
    // 下载工程数据中的模型文件
    // downloadEngineerFile(file, documentId, md5, materialFileMd5) {
    //   this.player.Native.File.EventDownloadProcessChanged.connect(this.progressMsg)
    //   this.player.Native.File.EventDownloadFinish.connect(
    //     this.downloadEngineerFileMsg(file, documentId, md5, materialFileMd5)
    //   )
    //   this.player.Native.File.downloadFile(
    //     file,
    //     'GET',
    //     `${this.currentEnv.VUE_APP_STANDARD_SERVER}/api/std/file/${md5}`,
    //     { Authorization: `${this.fullToken}` },
    //     (res) => {
    //       // 代表创建下载任务成功
    //       if (res) {
    //         this.loadType = '下载中...'
    //         this.showLoadProgress = true
    //       } else {
    //         this.$message.warning('下载模型失败')
    //       }
    //     }
    //   )
    // },
    // 模型文件下载完成
    // downloadEngineerFileMsg(file, documentId, md5, materialFileMd5) {
    //   const fun = async (fileName, err) => {
    //     this.loadPercentage = 0
    //     this.showLoadProgress = false
    //     this.player.Native.File.EventDownloadProcessChanged.disconnect(this.progressMsg)
    //     this.player.Native.File.EventDownloadFinish.disconnect(fun)
    //     if (err) {
    //       this.$message.warning(`下载文件失败1，${fileName}, ${err}`)
    //       this.engineerFileCount += 1
    //       return
    //     }
    //     if (materialFileMd5) {
    //       this.downloadEngineerMaterialFile(md5, materialFileMd5)
    //     } else {
    //       this.engineerFileCount += 1
    //     }
    //   }
    //   return fun
    // },
    // 下载工程数据中模型材质文件
    // downloadEngineerMaterialFile(modelMd5, md5) {
    //   this.player.Native.File.EventDownloadProcessChanged.connect(this.progressMsg)
    //   this.player.Native.File.EventDownloadFinish.connect(
    //     this.downloadEngineerMaterialMsg(modelMd5, md5)
    //   )
    //   this.player.Native.File.downloadFile(
    //     `data://../apps/${this.currentEnv.VUE_APP_CURRENT_PROJECT}/models/${modelMd5}/${modelMd5}.zip`,
    //     'GET',
    //     `${this.currentEnv.VUE_APP_STANDARD_SERVER}/api/std/file/${md5}`,
    //     { Authorization: `${this.fullToken}` },
    //     (res) => {
    //       // 代表创建下载任务成功
    //       if (res) {
    //         this.loadType = '下载中...'
    //         this.showLoadProgress = true
    //       } else {
    //         this.$message.warning('下载材质文件失败')
    //       }
    //     }
    //   )
    // },
    // 监听材质文件下载完毕
    // downloadEngineerMaterialMsg(modelMd5, md5) {
    //   const fun = async (fileName, err) => {
    //     this.showLoadProgress = false
    //     this.loadPercentage = 0
    //     this.player.Native.File.EventDownloadProcessChanged.disconnect(this.progressMsg)
    //     this.player.Native.File.EventDownloadFinish.disconnect(fun)
    //     this.engineerFileCount += 1
    //     if (err) {
    //       this.$message.warning(`下载文件失败2，${fileName}, ${err}`)
    //       return
    //     }
    //     await this.player.Native.UiQt.decompressingZIP(
    //       `data://../apps/${this.currentEnv.VUE_APP_CURRENT_PROJECT}/models/${modelMd5}/${modelMd5}.zip`,
    //       ''
    //     )
    //   }
    //   return fun
    // },
    // 模型全部下载完毕加载工程
    // async loadEngineerData() {
    //   await loadSceneFromJson(this.engineerSceneData, 0, this.player)
    // },
    /**
     * @description: 鼠标左键点击事件
     * @param {*} data
     * @return {*}
     */
    browseLClick: _.debounce(async function(data) {
      if (data && data.object) {
        let anchorSetting = ''
        if (
          this.userPreferenceSettings.Show &&
          this.userPreferenceSettings.Show.anchorPointInfoFrame &&
          !this.showPlayerSysSetting
        ) {
          anchorSetting = this.userPreferenceSettings.Show.anchorPointInfoFrame
        } else {
          const currentAnchorSetting = await this.player.Native.Settings.get('anchorPointInfoFrame')
          anchorSetting = currentAnchorSetting.value ? currentAnchorSetting.value : 'null'
        }
        let anchorCode = data.object
        while (anchorCode && !anchorCode.code && anchorCode.parentItem != 0) {
          anchorCode = await this.player.Native.ModelTree.getItemInfo(anchorCode.parentItem)
        }
        if (anchorCode && anchorCode.code && anchorSetting !== 'null') {
          // const res = await DocumentManagementService.getTagByCode({
          //   code: anchorCode.code,
          // })
          // if (res && res.code === 0 && res.data) {
          //   let markerText = ''
          //   if (anchorSetting === 'code') {
          //     markerText = `Code:${res.data.code}`
          //   } else if (anchorSetting === 'name') {
          //     markerText = `Name:${res.data.name}`
          //   } else if (anchorSetting === 'code+name') {
          //     markerText = `Code:${res.data.code}\nName:${res.data.name}`
          //   }
          //   this.drawAnchorInfo(anchorCode.code, markerText)
          // } else if (this.anchorMarkerId) {
          //   this.player.Native.GisMarker.destroy(this.anchorMarkerId)
          //   this.anchorMarkerId = null
          // }
        } else if (this.anchorMarkerId) {
          this.player.Native.GisMarker.destroy(this.anchorMarkerId)
          this.anchorMarkerId = null
        }
      }
    }, 400),
    /**
     * @description: 绘制锚点信息框
     * @param {*} text
     * @return {*}
     */
    async drawAnchorInfo(code, text) {
      const pos = await this.player.Native.Camera.getAnchorPos()
      if (!_.isNil(pos)) {
        const imgId = await this.player.Native.GisMarker.loadImage('rgba:85,91,93,255')

        const option = {
          pos, // 定位点，世界坐标，三维向量
          text: '', // 文本
          visible: true, // 显示隐藏状态
          size: [-1, 60], // 整体尺寸，二维向量，-1表示不限制，自动大小
          nodeOffset: [0, -60], // 相对定位点的偏移量，二维向量
          imgId, // 图片
          imgSize: [-1, 60], // 图片尺寸，-1为应用图片大小，如[32, -1]为宽度拉伸或压缩到32，高度为图片高度
          imgOffset: [0, 0], // 图片相对标记的偏移量
          fontSize: 20.0, // 字体大小
          breakWidth: -1, // 最大行宽，超过宽度会换行，-1表示限制，换行符（'\n'）会强制换行不受控制
          contentPadding: [10, 10, 10, 10], // 文字相对标记的偏移量
          textColor: 0xffffffff, // 文本颜色
          title: text, // 标题
          titleFontSize: 16.0, // 标题文字大小
          titleColor: 0xffffffff, // 标题颜色
          userData: null, // 用户数据，仅帮外部系统保存数据
        }
        // option里面的类容均为可选，但是option至少是{}，不能为null
        if (this.anchorMarkerId && this.anchorMarkerId !== 0) {
          this.player.Native.GisMarker.update(this.anchorMarkerId, option)
        } else {
          this.anchorMarkerId = await this.player.Native.GisMarker.create(option)
        }
      }
    },
    /**
     * @description: 获取用户偏好设置
     * @param {*} null
     * @return {*}
     */
    async getPreferenceSettings() {
      const res = await PreferenceSettingApi.getCurrentUserSetting()
      if (res) {
        this.userPreferenceSettings = res?.extraProperties
        this.setPreferenceSettings()
      }
    },
    /**
     * @description: 设置用户偏好设置
     * @param {*} null
     * @return {*}
     */
    // async setPreferenceSettings() { // 暂不处理
    //   if (this.userPreferenceSettings.Show) {
    //     const showSettings = await this.player.Native.Settings.getAll()
    //     _.forIn(this.userPreferenceSettings.Show, (value, key) => {
    //       const settingInfo = _.find(showSettings, ['name', key])
    //       if (settingInfo) {
    //         let currentValue = ''
    //         if (settingInfo.type === 'bool') {
    //           currentValue = value === 'true' || value === true
    //         } else if (
    //           settingInfo.type === 'int' ||
    //           settingInfo.type === 'float' ||
    //           settingInfo.type === 'double'
    //         ) {
    //           currentValue = _.toNumber(value)
    //         } else {
    //           currentValue = value
    //         }
    //         this.player.Native.Settings.set(key, settingInfo.type, currentValue)
    //       }
    //     })
    //   } else if (this.defaultSettings.Show) {
    //     _.forEach(this.defaultSettings.Show, (item) => {
    //       this.player.Native.Settings.set(item.name, item.type, item.value)
    //     })
    //   }
    //   const roamingSettings = this.userPreferenceSettings.RoamTrance
    //     ? this.userPreferenceSettings.RoamTrance
    //     : this.defaultSettings.RoamTrance
    //   _.forIn(roamingSettings, (value, key) => {
    //     let settingKeys = []
    //     if (this.userPreferenceSettings.RoamTrance) {
    //       settingKeys = _.reduce(
    //         JSON.parse(value),
    //         (arr, item) => {
    //           arr.push(item.split('+'))
    //           return arr
    //         },
    //         []
    //       )
    //     } else {
    //       settingKeys = _.reduce(
    //         value,
    //         (arr, item) => {
    //           arr.push(item.split('+'))
    //           return arr
    //         },
    //         []
    //       )
    //     }
    //     this.player.Native.Walking.setHotkey(key, settingKeys)
    //   })
    //   const RoamingSpeed = roamingSettings.RoamingSpeed || 1
    //   this.player.Native.Walking.setAvatarMoveSpeed(RoamingSpeed)
    //   const figureSettings = this.userPreferenceSettings.People
    //     ? this.userPreferenceSettings.People
    //     : this.defaultSettings.Skin
    //   const isExists = await this.player.Native.File.exists(
    //     `data://../apps/${this.currentEnv.VUE_APP_CURRENT_PROJECT}/skin`
    //   )
    //   if (isExists) {
    //     this.player.Native.Walking.setAvatarBodySkin(
    //       `data://../apps/${this.currentEnv.VUE_APP_CURRENT_PROJECT}/skin/${figureSettings.avatarBodySkin}`
    //     )
    //     this.player.Native.Walking.setAvatarCapSkin(
    //       `data://../apps/${this.currentEnv.VUE_APP_CURRENT_PROJECT}/skin/${figureSettings.avatarCapSkin}`
    //     )
    //   }
    // },
    /**
     * 通过默认的defaultModelId(即documentId确认模型，并进行定位)
     * 有默认视角，优先通过默认视角定位
     */
    async defaultPositioning(id) {
      if (!this.curModelList.length) return // 未加载成功模型就不做处理
      const defaultModelIndex = _.findIndex(this.curModelList, ['documentId', id])
      let curModelInfo
      if (defaultModelIndex > -1) {
        // 加载成功的模型中有默认模型
        curModelInfo = this.curModelList[defaultModelIndex]
      } else {
        // 没有默认的就选第一个
        curModelInfo = this.curModelList[0]
      }
      // const llh = [106.36232040372178, 31.475661302844625, 517.9275416191667]
      await this.locateModel(this.LLH, curModelInfo)
      if (this.modelParams[0].CameraPosition) {
        console.log('默认视角定位')
        // 有默认视角通过默认视角定位
        const { eye, target, up } = JSON.parse(this.modelParams[0].CameraPosition)
        console.log('eye, target, up', eye, target, up)
        this.player.Native.Camera.addMoveTo(eye, target, up, 2)
      } else if (this.GisLoaded && this.LLH?.length) {
        console.log('经纬度定位')
        await this.player.Native.Camera.moveToLLH([this.LLH[0], this.LLH[1], 2000], 5)
      } else if (curModelInfo.node) {
        // 无默认视角通过模型节点定位
        console.log('通过node定位')
        await this.player.Native.Camera.moveToNode(curModelInfo.node, 2, 25)
      }
    },
    // 设置模型位置
    async locateModel(llh, curModelInfo) {
      if (this.GisLoaded && llh?.length) {
        let node
        if (this.preloadEngineId && this.noSwitchModel) {
          // 预加载并且未切换过模型
          const rootNode = await this.player.Native.Node.getRoot()
          const rootInfo = await this.player.Native.Node.getProperty(rootNode, ['children'])
          node = rootInfo.children[0].node
        } else {
          node = curModelInfo.node
        }
        // 如果没有高程，则获取地面高度
        if (!llh[2]) {
          llh[2] = (await this.player.Native.GisPlatform.queryDEM([llh]))[0]
        }
        // 通过经纬度计算旋转偏移量和最终的模型世界坐标位置
        const mat = await this.player.Native.GisPlatform.makeMatrixByLLH(llh, [0, 0, 0], [1, 1, 1])
        const decomposeRes = this.matrix4Decompose(mat)
        await this.player.Native.Node.setProperty(node, {
          globalTrans: decomposeRes.position,
          localRot: decomposeRes.quaternion,
        })
      }
    },
    vec3Length(a) {
      return Math.sqrt(a[0] * a[0] + a[1] * a[1] + a[2] * a[2])
    },
    // 解析矩阵
    matrix4Decompose(m) {
      const a = {}

      const vx = [m[0], m[1], m[2]]
      const vy = [m[4], m[5], m[6]]
      const vz = [m[8], m[9], m[10]]

      let sx = this.vec3Length(vx)
      const sy = this.vec3Length(vy)
      const sz = this.vec3Length(vz)

      // if determine is negative, we need to invert one scale
      const det = this.matrix4Determinant(m)
      if (det < 0) sx = -sx

      a.position = []
      a.position[0] = m[12]
      a.position[1] = m[13]
      a.position[2] = m[14]

      // scale the rotation part
      const rMat = m
      rMat[12] = 0
      rMat[13] = 0
      rMat[14] = 0

      const invSX = 1 / sx
      const invSY = 1 / sy
      const invSZ = 1 / sz

      rMat[0] *= invSX
      rMat[1] *= invSX
      rMat[2] *= invSX

      rMat[4] *= invSY
      rMat[5] *= invSY
      rMat[6] *= invSY

      rMat[8] *= invSZ
      rMat[9] *= invSZ
      rMat[10] *= invSZ

      a.rotation = rMat
      a.quaternion = this.fromRotationMatrix(rMat)

      a.scale = []
      a.scale[0] = sx
      a.scale[1] = sy
      a.scale[2] = sz

      return a
    },
    /**
     * 计算矩阵行列式
     * @param {*} m 将被计算行列式的矩阵对象
     * @returns 矩阵的行列式值
     */
    matrix4Determinant(m) {
      const n11 = m[0]
      const n12 = m[1]
      const n13 = m[2]
      const n14 = m[3]
      const n21 = m[4]
      const n22 = m[5]
      const n23 = m[6]
      const n24 = m[7]
      const n31 = m[8]
      const n32 = m[9]
      const n33 = m[10]
      const n34 = m[11]
      const n41 = m[12]
      const n42 = m[13]
      const n43 = m[14]
      const n44 = m[15]

      return (
        n41 *
          (+n14 * n23 * n32 -
            n13 * n24 * n32 -
            n14 * n22 * n33 +
            n12 * n24 * n33 +
            n13 * n22 * n34 -
            n12 * n23 * n34) +
        n42 *
          (+n11 * n23 * n34 -
            n11 * n24 * n33 +
            n14 * n21 * n33 -
            n13 * n21 * n34 +
            n13 * n24 * n31 -
            n14 * n23 * n31) +
        n43 *
          (+n11 * n24 * n32 -
            n11 * n22 * n34 -
            n14 * n21 * n32 +
            n12 * n21 * n34 +
            n14 * n22 * n31 -
            n12 * n24 * n31) +
        n44 *
          (-n13 * n22 * n31 -
            n11 * n23 * n32 +
            n11 * n22 * n33 +
            n13 * n21 * n32 -
            n12 * n21 * n33 +
            n12 * n23 * n31)
      )
    },
    /**
     * 转换旋转矩阵到四元数
     * @param {*} m 旋转矩阵
     * @returns 旋转四元数
     */
    fromRotationMatrix(m) {
      const m11 = m[0]
      const m12 = m[4]
      const m13 = m[8]
      const m21 = m[1]
      const m22 = m[5]
      const m23 = m[9]
      const m31 = m[2]
      const m32 = m[6]
      const m33 = m[10]
      const trace = m11 + m22 + m33

      const q = []

      if (trace > 0) {
        const s = 0.5 / Math.sqrt(trace + 1.0)

        q[0] = 0.25 / s
        q[1] = (m32 - m23) * s
        q[2] = (m13 - m31) * s
        q[3] = (m21 - m12) * s
      } else if (m11 > m22 && m11 > m33) {
        const s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33)

        q[0] = (m32 - m23) / s
        q[1] = 0.25 * s
        q[2] = (m12 + m21) / s
        q[3] = (m13 + m31) / s
      } else if (m22 > m33) {
        const s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33)

        q[0] = (m13 - m31) / s
        q[1] = (m12 + m21) / s
        q[2] = 0.25 * s
        q[3] = (m23 + m32) / s
      } else {
        const s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22)

        q[0] = (m21 - m12) / s
        q[1] = (m13 + m31) / s
        q[2] = (m23 + m32) / s
        q[3] = 0.25 * s
      }

      return q
    },
    /**
     * @description: 通过模型名称来移动到模型
     * @param {*} 模型名称
     * @return {*}
     */

    async moveBymodelName(modelName) {
      const modelInfo = await PlayerUtils.call(this.player.Native.Model.getInfo, modelName)
      const currentModel = _.filter(this.modelParams, ['documentId', modelName])
      // 切换模型
      this.currentFileId = currentModel[0].fileId
      // 获取模型的空间坐标位置
      const modelPosistion = await PlayerUtils.call(
        this.player.Native.NodeProxy.globalTranslation,
        modelInfo.nodePtr
      )
      if (this.code) {
        const codeInfo = await this.player.Native.ModelTree.getItemByCode(
          decodeURIComponent(this.code)
        )
        if (codeInfo.item) {
          this.player.Native.ModelTree.setSelectItem(codeInfo.item)
          const { aabb, localMatrix } = await this.player.Native.ModelTree.calcItemAabb(
            codeInfo.item
          )
          this.player.Native.Camera.addMoveToAabb(aabb, localMatrix, 5, 1.1, 2)
        }
        return
      }
      // 获取模型默认位置（相对模型中心点的偏移量）
      if (_.isEmpty(currentModel) || !currentModel[0].CameraPosition) {
        modelInfo.item = modelInfo.treeItem
        // 通过documentId获取模型的动态模板属性
        const modelTemplateInfo = _.find(this.modelParams, ['documentId', modelName])
        await multipleLocations(this.player, modelInfo, false, modelTemplateInfo)
        if (this.$route.query.code) {
          const codeInfo = await this.player.Native.ModelTree.getItemByCode(
            decodeURIComponent(this.$route.query.code)
          )
          if (codeInfo.item) {
            await this.player.Native.ModelTree.setSelectItem(codeInfo.item)
            const { aabb, localMatrix } = await this.player.Native.ModelTree.calcItemAabb(
              codeInfo.item
            )
            this.player.Native.Camera.addMoveToAabb(aabb, localMatrix, 1, 1.1, 2)
          }
        }
        return
      }
      const { eye, target, up } = await restore(
        this.player,
        modelName,
        JSON.parse(currentModel[0].CameraPosition),
        currentModel[0].Model_Offset,
        this.isAddLoadMap()
      )
      if (this.isAddLoadMap()) {
        // 缓慢降低相机的高度，不适用模型放置在高海拔
        const cameraCurrParam = await PlayerUtils.call(this.player.Native.Camera.currentParam)
        const currEyeHeight = Vec3.length(cameraCurrParam.eye)
        const tarEyeHeight = Vec3.length(eye)
        const heightOffset = currEyeHeight - tarEyeHeight
        const tarEyeLLH = await PlayerUtils.call(this.player.Native.GisPlatform.worldToLLH, eye)

        let h0 = tarEyeLLH[2] + heightOffset * 0.2
        h0 = Math.max(h0, tarEyeLLH[2] + 2000.0)
        this.player.Native.Camera.addMoveToLLH([tarEyeLLH[0], tarEyeLLH[1], h0], 1.5)

        let h1 = tarEyeLLH[2] + heightOffset * 0.05
        h1 = Math.max(h1, tarEyeLLH[2] + 500)
        this.player.Native.Camera.addMoveToLLH([tarEyeLLH[0], tarEyeLLH[1], h1], 1.5)
      }
      await this.player.Native.Camera.addMoveTo(eye, target, up, 2)
    },
    // 判断是否加载地球
    isAddLoadMap(callback) {
      if (!_.isNil(this.modelProps.sceneOpenType) && String(this.modelProps.sceneOpenType)) {
        if (this.modelProps.sceneOpenType === 0) {
          callback && callback()
          return true
        }
      } else if (
        this.currentProject &&
        this.currentProject.latitude &&
        this.currentProject.longitude
      ) {
        callback && callback()
        return true
      }
      return false
    },
    // 检查模型材质文件
    async checkModelMaterialVk(item) {
      if (item.textureInfoId) {
        // 有材质
        const url = `data://../apps/${this.currentEnv.VUE_APP_CURRENT_PROJECT}/models/${item.md5}/${item.textureInfoId}.zip`
        const isExist = await this.player.Native.File.exists(url)
        if (isExist) {
          // 材质文件存在
          this.getCurrentModelFileVk(item)
        } else {
          // 材质文件不存在
          this.downloadMaterialVk(item)
        }
      } else {
        // 无材质
        this.getCurrentModelFileVk(item)
      }
    },
    // 下载材质文件
    async downloadMaterialVk(item) {
      const params = [
        `data://../apps/${this.currentEnv.VUE_APP_CURRENT_PROJECT}/models/${item.md5}/${item.textureInfoId}.zip`,
        'GET',
        `${this.currentEnv.VUE_APP_STANDARD_SERVER}/api/std/file/${item.textureInfoId}`,
        {
          Authorization: `Bearer ${Wiz.AuthHooks.GetToken()}`,
        },
      ]
      const res = await download3dFileVk(
        this.player,
        params,
        this.downloadProcessVk,
        this.downloadMaterialFinishVk
      )
      if (res) {
        // 创建下载成功
        this.showLoadProgress = true
        this.loadPercentage = 0
        this.loadType = '材质下载中...'
      } else {
        // 创建下载失败（Url不合法或者文件无法写入）
        this.$message.warning('创建材质下载任务失败')
        this.getCurrentModelFileVk(item)
      }
    },
    /**
     * @description 下载完成
     * @param file 文件
     * @param err 如果下载成功应为空字符串，否则为错误信息
     * @param bytesTotal 响应内容的总字节数
     */
    downloadMaterialFinishVk(file, err, bytesTotal) {
      this.showLoadProgress = false
      this.loadPercentage = 0
      console.log('材质下载结束', file)
      if (err) {
        this.$message.warning(`下载贴图文件失败，${file}, ${err}`)
      }
      setTimeout(() => {
        this.getCurrentModelFileVk(this.currentModelInfo)
      }, 1500)
    },
    /**
     * @description 下载进度
     * @param file 文件
     * @param bytesReceived 已接收字节数
     * @param bytesTotal 总字节数，小于等于0表示未知大小
     */
    downloadProcessVk(file, bytesReceived, bytesTotal) {
      this.loadPercentage = 0
      if (bytesTotal) {
        this.loadPercentage = (bytesReceived / bytesTotal) * 100
      }
    },
    /**
     * @description: 检查是否模型是否存在 不存在则下载
     * @param {*}
     * @return {*}
     */
    async checkModel() {
      console.log('this.modelParams', this.modelParams)
      if (!this.modelParams.length && !this.$route.query.engineerId) {
        this.$message.error('当前项目没有模型')
        this.$emit('loadingSwitch', { bol: false, title: '当前项目没有模型' })
        this.$emit('loadError', '当前项目没有模型')
        return
      }
      if (this.curModelSerialNum === this.modelParams.length) {
        // 加载完成就停止，并重置当前加载序号
        console.log('全部加载完成')
        if (Wiz.globalSettings.globalConfig.modelSetting.pixelRatio) {
          this.cloudRender.Engine.setPixelRatio(
            Wiz.globalSettings.globalConfig.modelSetting.pixelRatio
          )
        }

        this.curModelSerialNum = 0
        this.modelTreeProp.loadModelStatus = true
        this.$emit('loadingSwitch', { bol: false, title: '加载完成' })
        this.currentFileId = this.curModelList[0].fileId
        this.defaultPositioning(this.modelProps.defaultModelId) // 定位到默认模型
        this.$emit('LoadedAllModel')
        return
      }
      switch (this.modelParams[this.curModelSerialNum].name) {
        case '外输管线':
          console.log('这里是加载管道逻辑')
          break
        case '杆塔模型':
          console.log('这里是加载杆塔模型逻辑')
          break
        case '广告牌':
          console.log('找到广告牌')
          // this.addBoard(this.modelParams[this.curModelSerialNum]) // 暂不处理
          break
        default:
          // 单线程，防止并发下载或加载中，三维监听方法交错
          this.checkModelMaterialVk(this.modelParams[this.curModelSerialNum])
          break
      }
      this.currentModelInfo = this.modelParams[this.curModelSerialNum]
    },
    // 模型
    async getCurrentModelFileVk(item) {
      const md5Res = await this.player.Native.File.getFileMd5(
        `data://../apps/${this.currentEnv.VUE_APP_CURRENT_PROJECT}/models/${item.md5}/${item.md5}.${item.type}`
      )
      if (md5Res && md5Res.toLowerCase() === item.md5.toLowerCase()) {
        // 有模型就加载模型
        this.addModelVk(item)
      } else {
        // 校验md5失败
        this.downloadModelVk(item)
      }
    },
    // 下载模型
    async downloadModelVk(item) {
      const params = [
        `data://../apps/${this.currentEnv.VUE_APP_CURRENT_PROJECT}/models/${item.md5}/${item.md5}.${item.type}`,
        'GET',
        `${this.currentEnv.VUE_APP_STANDARD_SERVER}/api/std/file/${item.fileId}`,
        {
          Authorization: `Bearer ${Wiz.AuthHooks.GetToken()}`,
        },
      ]
      const res = await download3dFileVk(
        this.player,
        params,
        this.downloadProcessVk,
        this.downloadModelFinishVk
      )
      if (res) {
        // 创建下载成功
        this.showLoadProgress = true
        this.loadPercentage = 0
        this.loadType = '模型下载中...'
      } else {
        // 创建下载失败（Url不合法或者文件无法写入）
        this.$message.warning('创建模型下载失败')
        this.$emit('loadError', '创建模型下载失败')
        this.curModelSerialNum += 1
        this.checkModel()
      }
    },
    /**
     * @description: 下载模型
     * @param {*} playerName：模型名称
     * @param {*} type： 模型类型
     * @return {*}
     */
    async downloadFile(playerId, type, item) {
      this.curBytesTotal = null
      if (item.fileId) {
        await this.getFileInfoByFileId(item.fileId)
      }
      this.player.Native.File.EventDownloadProcessChanged.connect(this.progressMsg)
      this.player.Native.File.EventDownloadFinish.connect(this.downloadMsg(playerId, item, type))
      this.player.Native.File.downloadFile(
        `data://../apps/${this.currentEnv.VUE_APP_CURRENT_PROJECT}/models/${playerId}/${playerId}.${type}`,
        'GET',
        `${this.currentEnv.VUE_APP_STANDARD_SERVER}/api/std/file/${item.fileId}`,
        { Authorization: `${this.fullToken}` },
        (res) => {
          // 代表创建下载任务成功
          if (res) {
            this.showLoadProgress = true
            this.loadType = '下载中...'
          } else {
            this.$message.warning('下载模型失败')
            this.$emit('loadError', '下载模型失败')
          }
        }
      )
    },
    // 通过fileId获取文件的详细信息
    async getFileInfoByFileId(fileid) {
      const res = await DocumentService.getDocumentFileType({
        fileId: fileid,
        standardId: localStorage.getItem('standardId') || this.$route.query.standardId,
        isVersion: false,
      })
      if (res && res.code === 0 && res.data) {
        this.fileId = res.data.fileId
        this.curBytesTotal = res.data.size
      }
    },
    // 监听下载进度
    progressMsg(file, bytesReceived, bytesTotal) {
      if (bytesTotal > 0) {
        this.loadPercentage = (bytesReceived / bytesTotal) * 100
      } else if (this.curBytesTotal) {
        this.loadPercentage = (bytesReceived / this.curBytesTotal) * 100
      }
    },
    // 监听模型下载结束
    downloadModelFinishVk(file, err, bytesTotal) {
      this.showLoadProgress = false
      this.loadPercentage = 0
      if (err) {
        this.$message.warning(`下载模型文件失败，${file}, ${err}`)
        this.$emit('loadError', `下载模型文件失败，${file}, ${err}`)
        this.curModelSerialNum += 1
        this.checkModel()
        return
      }
      this.addModelVk(this.currentModelInfo)
    },
    // 监听下载模型是否成功
    downloadMsg(playerId, item, type) {
      const _this = this
      const fun = async (file, err) => {
        this.loadPercentage = 0
        _this.showLoadProgress = false
        if (err) {
          _this.addModelNum += 1
          _this.$message.warning(`下载文件失败，${file}, ${err}`)
          _this.$emit('loadError', `下载模文件失败，${file}, ${err}`)
          return
        }
        if (
          file ===
          `data://../apps/${this.currentEnv.VUE_APP_CURRENT_PROJECT}/models/${playerId}/${playerId}.${type}`
        ) {
          _this.player.Native.File.EventDownloadFinish.disconnect(fun) // 断开下载
          _this.player.Native.File.EventDownloadProcessChanged.disconnect(_this.progressMsg)
          switch (type) {
            case 'pr':
              // 检查当前md5和远程下载的md5是否一致
              _this.player.Native.File.getFileMd5(
                `data://../apps/${this.currentEnv.VUE_APP_CURRENT_PROJECT}/models/${playerId}/${playerId}.${type}`,
                (res) => {
                  if (res !== playerId.toLowerCase()) {
                    _this.$message.warning('当前请求的md5和服务器下载的md5不一致！')
                    _this.$emit('loadError', '当前请求的md5和服务器下载的md5不一致！')
                  }
                }
              )
              _this.addModel(playerId, file, item) // 模型下载成功就加载模型
              break
            case 'demMask':
              // 有模型附件就调用地形融合方法
              _this.player.Native.Model.loadDemMaskFile(
                item.documentId,
                `data://../apps/${this.currentEnv.VUE_APP_CURRENT_PROJECT}/models/${playerId}/${playerId}.${type}`
              )
              break
            case _this.modelAnimationSuffix:
              _this.loadAnimationFile(item)
              break
            case 'node':
              await addBoardNode(
                item.merchantId,
                `data://../apps/${this.currentEnv.VUE_APP_CURRENT_PROJECT}/models/${item.md5}/${item.md5}.pr`,
                item,
                this.player,
                this.checkModelLoad,
                this.checkModelLoadEnd,
                this.fullToken
              )
              this.addModelNum += 1
              break
            default:
              break
          }
        }
      }
      return fun
    },
    async addModelVk(item) {
      this.player.Native.Node.EventLoadFileProgressStart.connect(this.loadModelStart)
      this.player.Native.Node.EventLoadFileProgress.connect(this.loadModelProgress)
      this.player.Native.Node.EventLoadFileFinish.connect(this.loadModelFinish)
      try {
        // 加载工程模型
        this.taskId = await this.player.Native.Node.loadFile(
          `data://../apps/${this.currentEnv.VUE_APP_CURRENT_PROJECT}/models/${item.md5}/${item.md5}.${item.type}`,
          false,
          true
        )
      } catch (error) {
        this.taskId = null
        this.$message.warning('模型加载失败', error.message)
        this.$emit('loadError', error.message)
        this.curModelSerialNum += 1
        this.checkModel()
      }
    },
    // 加载开始监听
    loadModelStart(t, val) {
      this.loadType = '模型加载中...'
      this.showLoadProgress = true
      this.loadPercentage = val * 100
    },

    // 加载进度监听
    loadModelProgress(t, val) {
      this.loadPercentage = val * 100
    },

    // 监听加载结束
    async loadModelFinish(t, nds) {
      if (t === this.taskId) {
        const rootNode = await this.player.Native.Node.getRoot()
        let bUpdate = false
        for (let i = 0; i < nds.length; i += 1) {
          // eslint-disable-next-line no-await-in-loop
          bUpdate = await this.player.Native.Node.setProperty(nds[i], {
            parent: rootNode,
          })
        }
        if (bUpdate) {
          await this.player.Native.Node.update(rootNode)
        }
        await this.player.Native.Node.addToFactory(nds)
        // 加载模型完成
        this.showLoadProgress = false
        this.loadPercentage = 0
        this.taskId = null // 清除任务id
        this.curModelSerialNum += 1
        this.curModelList.push({
          ...this.currentModelInfo,
          node: nds[0],
        })
        this.checkModel()
        this.currentModelInfo = this.$options.data().currentModelInfo
      }
      this.player.Native.Node.EventLoadFileProgressStart.disconnect(this.loadModelStart)
      this.player.Native.Node.EventLoadFileProgress.disconnect(this.loadModelProgress)
      this.player.Native.Node.EventLoadFileFinish.disconnect(this.loadModelFinish)
    },
    /**
     * @description: 加载模型
     * @param {*} name
     * @param {*} url
     * @param {*} item
     * @return {*}
     */

    async addModel(name, url, item) {
      const resList = await PlayerUtils.call(
        this.player.Native.Model.loadModel,
        item.documentId,
        url
      ) // 加载模型
      if (resList || resList === null) {
        this.addModelNum++
        this.$message.error(resList)
        this.$emit('loadError', resList)
        return
      }
      // 加载模型材质文件
      this.player.Native.Model.loadItemMaterial(item.documentId)
      // 获取模型的指针对象
      const modelPr = await PlayerUtils.call(this.player.Native.Model.getInfo, item.documentId)
      item.nodePtr = modelPr.nodePtr
      this.ModelMapList.push({
        name: modelPr.modelPtr,
        documentId: item.documentId,
        fileName: item.name,
      })
      // // 根据模型获取模型附件md5  // 暂不处理
      // await this.getDemPlayerId(name, item.documentId)
      // // 加载模型完成后判断远程是否有模型附件，如果有就判断本地有没有该模型附件，如果没有就下载模型附件，如果有就直接拿到文件然后调用loadDemMaskFile方法，加载地形融合文件，如果远程上没有就不管
      // if (this.demPlayerId) {
      //   this.checkFileIsExist(this.demPlayerId, 'demMask', item, () => {
      //     // 有模型附件就加载模型
      //     this.player.Native.Model.loadDemMaskFile(
      //       item.documentId,
      //       `data://../apps/${this.currentEnv.VUE_APP_CURRENT_PROJECT}/models/${this.demPlayerId}/${this.demPlayerId}.demMask`
      //     )
      //   })
      // }
      // // 判断是否加载地球
      // if (this.isAddLoadMap()) {
      //   // 加载地球后的操作
      //   const latitude = item.Latitude
      //   const longitude = item.Longitude
      //   const llh = [longitude, latitude, item.Elevation] // 获取经纬度和高度向量
      //   // 设置地形攀爬
      //   await PlayerUtils.call(
      //     this.player.Native.NodeProxy.setNodeClampTerrain,
      //     item.nodePtr,
      //     item.IsAutoFollowFloor
      //   )
      //   if (item.IsAutoFollowFloor) {
      //     // 查询经纬度的高程信息,返回的是数组,批量查询结果与单个查询一致，但性能更高
      //     llh[2] =
      //       (
      //         await PlayerUtils.call(this.player.Native.GisPlatform.queryDEM, [
      //           [longitude, latitude],
      //         ])
      //       )[0] || 0
      //   }
      //   // 设置模型位置
      //   await PlayerUtils.call(this.player.Native.NodeProxy.setNodeGisPos, item.nodePtr, llh)
      //   // 设置模型的旋转
      //   await PlayerUtils.call(this.player.Native.NodeProxy.setNodeRotation, item.nodePtr, [
      //     item.X_Axis_Angle || 0,
      //     item.Y_Axis_Angle || 0,
      //     item.Z_Axis_Angle || 0,
      //   ])
      //   await PlayerUtils.call(
      //     this.player.Native.NodeProxy.setNodeClampOffset,
      //     item.nodePtr,
      //     item.Model_Offset || 0
      //   ) // 设置地形攀爬偏移量
      // }
      // // 场景中心过来，加载动画
      // if (String(this.modelProps.sceneOpenType)) {
      //   // 检查动画文件是否存在，存在就直接加载，不存在就先下载动画文件
      //   if (item.aniMd5) {
      //     this.checkFileIsExist(item.aniMd5, this.modelAnimationSuffix, item, async () => {
      //       this.loadAnimationFile(item)
      //     })
      //   }
      // }
      this.addModelNum += 1
    },
    // 加载动画文件
    async loadAnimationFile(item) {
      // 动画文件存在，加载动画
      const animationFileUrl = `data://../apps/${this.currentEnv.VUE_APP_CURRENT_PROJECT}/models/${item.aniMd5}/${item.aniMd5}.${this.modelAnimationSuffix}`
      const animationClip = await PlayerUtils.call(
        this.player.Native.AnimationClip.fromXmlData,
        this.mixerObj,
        item.nodePtr,
        animationFileUrl
      )
      const animationAction = await PlayerUtils.call(
        this.player.Native.AnimationAction.clipAction,
        this.mixerObj,
        animationClip
      )
      await PlayerUtils.call(this.player.Native.AnimationAction.play, animationAction)
    },
    /**
     * @description: 根据模型获取对应的模型附件信息
     * @param {*} name 模型附件的md5
     * @return {*}
     */

    async getDemPlayerId(name, documentId) {
      const params = {
        id: documentId,
        standardId: localStorage.getItem('standardId') || '',
      }
      // 是否是历史版本预览
      if (this.isVersion === '1') {
        params.isVersion = true
        params.classId = this.classId
      }
      const res = await DocumentManagementService.getFileList(params)
      if (res.success && res.data) {
        // 获取当前模型的信息
        const playerInfo = _.filter(res.data, (res) => {
          return res.md5 === name
        })
        // 根据当前模型的信息找到对应的模型附件信息
        const otherPlayerInfo = _.filter(res.data, (res) => {
          return (
            playerInfo[0] &&
            res.documentName === playerInfo[0].documentName &&
            res.fileType === '.demMask'
          )
        })
        this.demPlayerId = otherPlayerInfo[0] ? otherPlayerInfo[0].md5 : ''
      } else {
        this.demPlayerId = ''
      }
    },
    // 检测文件是否存在
    checkFileIsExist(playerId, type, item, callback) {
      this.player.Native.File.getFileMd5(
        `data://../apps/${this.currentEnv.VUE_APP_CURRENT_PROJECT}/models/${playerId}/${playerId}.${type}`,
        (res) => {
          if (res && playerId && res === playerId) {
            callback && callback()
            return
          }
          // 没有就下载模型附件
          this.downloadFile(playerId, type, item)
        }
      )
    },
    /**
     * @description: 监听模型加载进度
     * @param {*} data
     * @return {*}
     */

    checkModelLoad(data) {
      this.loadType = '加载中...'
      this.showLoadProgress = true
      this.loadPercentage = data * 100
    },
    /**
     * @description: 监听模型加载完成
     * @param {*} data
     * @return {*}
     */
    async checkModelLoadEnd(data) {
      this.showLoadProgress = false
      this.player.Native.Model.EventProgress.disconnect(this.checkModelLoad)
      this.player.Native.Model.EventProgressEnd.disconnect(this.checkModelLoadEnd)
      // 本地存储中有存储视角时进行弹窗确认
      const currentViewStr = await localStorage.getItem('currentView')
      if (currentViewStr) {
        const currentViewObjList = JSON.parse(currentViewStr)
        const currentViewObj = currentViewObjList.find((item) => {
          return item.lastModelId === this.$route.query.documentId
        })
        if (currentViewObj) {
          setTimeout(() => {
            this.isShowLocalForageView = true
          }, 500)
          return
        }
        setTimeout(() => {
          this.switchToDefaultView()
        }, 1000)
      }
    },
    switchToDefaultView() {
      // 移动到默认视角
      const defaultViewEye = [6378156.791163278, -412.19852773970547, 488.96201134595054]
      const defaultViewUp = [0.1914737964294742, 0.19827692049928466, 0.9612616959383147]
      const defaultViewTarget = [6379342.5, 815.638916015625, -0.4822280704975128]
      this.player.Native.Camera.moveTo(defaultViewEye, defaultViewTarget, defaultViewUp, 2)
    },
    // 恢复本地视角
    restoreLocalView() {
      this.switchToLocalForageView()
    },
    // 每次转动视角时,自动保存当前视角于本地存储
    async submitLocalForageView() {
      if (!this.player) return
      // 获取当前视角的经纬度
      const currentView = await this.player.Native.Camera.currentParam()
      // 判断是否已经存储，已存储则更新，未存储则存储
      const currentViewList = await localStorage.getItem('currentView')
      if (currentViewList) {
        const currentFuncViewList = JSON.parse(currentViewList)
        const currentFuncView = currentFuncViewList.find((item) => {
          return item.lastModelId === this.$route.query.documentId
        })
        if (currentFuncView) {
          localStorage.setItem(
            'currentView',
            JSON.stringify(
              currentFuncViewList.map((item) => {
                return item.lastModelId === this.$route.query.documentId
                  ? { ...item, ...currentView }
                  : item
              })
            )
          )
        } else {
          localStorage.setItem(
            'currentView',
            JSON.stringify([
              ...currentFuncViewList,
              { ...currentView, lastModelId: this.$route.query.documentId },
            ])
          )
        }
      } else {
        localStorage.setItem(
          'currentView',
          JSON.stringify([{ ...currentView, lastModelId: this.$route.query.documentId }])
        )
      }
    },
    // 切换至本次存储中保存的视角
    async switchToLocalForageView() {
      const currentViewStr = await localStorage.getItem('currentView')
      if (currentViewStr) {
        const currentFuncViewList = JSON.parse(currentViewStr)
        const currentFuncView = currentFuncViewList.find((item) => {
          return item.lastModelId === this.$route.query.documentId
        })
        if (currentFuncView) {
          await this.player.Native.Camera.moveTo(
            currentFuncView.eye,
            currentFuncView.target,
            currentFuncView.up,
            2
          )
        }
      }
    },
    /**
     * @description: 模型点选
     * @param {code,item,name,ownModel,parentItem,item} data
     * @return {*}
     */
    watchMsg(data) {
      if (data) {
        // if (this.modelTreeProp.currentNodeItem) {
        //   this.player.Native.ModelTree.restoreItemColor(this.modelTreeProp.currentNodeItem)
        // }
        this.currentItem = data.item
        // 点选触发模型树定位
        this.doLocation(data, `pickUp${this.playerEngineDomId}`)
        // 获取选中模型节点的name
        this.modelTreeProp.currentNodeName = data ? data.name : ''
        this.$emit('updateModelNode', data)
      } else {
        this.centerCode = ''
      }
    },
    // 鼠标点选选中监听
    async pickupWatch(data) {
      console.log(data, 'data-1122')
      if (data.node) {
        const res = await this.player.Native.Node.getProperty(data.node, ['code', 'name'])
        console.log(res, 'res-11')
        this.modelTreeProp.currentNodeName = res?.name ? res.name : ''
        this.$emit('updateModelNode', res)
        // 获取设备详细信息
        // data.documentId = _.find(this.ModelMapList, ['name', data.ownModel]).documentId
        res.documentId = this.curModelList[0].documentId
        this.centerCode = res.code
        if (res.code) {
          this.$emit('modelClick', res, `pickUp${this.playerEngineDomId}`)
        }
        this.triggerType = 'clickModel'
      } else {
        this.centerCode = ''
      }
    },
    /**
     * @description:移动摄像机的位置(兼容多模型定位)
     * @param {*} type :modelTree无需定位
     * @return {*}
     */
    async moveCamera(code, type) {
      if (this.curModelList.length && this.curModelList[0].node) {
        if (code === '' && type === 'PickupCenter') {
          this.currentNode = this.curModelList[0].node
          this.player.Native.Camera.moveToNode(this.curModelList[0].node, 1, 0)
          return
        }
        // 暂不考虑多模型情况，第一个模型节点即顶点
        const node = await this.player.Native.Node.findNodeByCode(this.curModelList[0].node, code)
        if (node) {
          this.currentNode = node
          const nodeInfo = await this.player.Native.Node.getProperty(node, ['code', 'name'])
          this.modelTreeProp.currentNodeName = nodeInfo.name
          this.player.Native.Node.selectNodes([node])
          // 模型树状态下不触发定位
          if (this.codeChangeType === 'modelTree') return
          this.player.Native.Camera.moveToNode(node, 1, 0)
        } else {
          console.log(this.curModelList[0].node, this.curModelList, 'curModelList-1111')
          this.player.Native.Node.unSelectNodes([this.currentNode])
          this.currentNode = this.curModelList[0].node
          console.log(this.currentNode, 'currentNode')
          this.triggerType = ''
        }
      }
      // const modelInfo = await this.player.Native.Model.getInfo(this.modelName)
      // if (modelInfo) {
      //   if (code === '' && type === 'PickupCenter') {
      //     this.currentItem = modelInfo.treeItem
      //     this.player.Native.Camera.moveToItem(modelInfo.treeItem, 2)
      //     return
      //   }
      //   const nodeInfo = await this.player.Native.ModelTree.findItemByCode(code, modelInfo.treeItem)
      //   if (nodeInfo) {
      //     this.currentItem = nodeInfo.item
      //     this.player.Native.ModelTree.setSelectItemNoEvent(nodeInfo.item)
      //     // 获取选中模型节点的name
      //     this.modelTreeProp.currentNodeName = nodeInfo.name
      //     // 模型树状态下不触发定位
      //     if (this.codeChangeType === 'modelTree') return
      //     this.player.Native.Camera.moveToItem(nodeInfo.item, 2)
      //   }
      // }
    },
    removeTagsStatus(removeTags, status) {
      // 测量工具集合
      const measureList = {
        M_Line: 1, // 两点测量
        M_Point: 2, // 多点测量
        M_Vertical: 3, // 高度测量
        M_Stereo: 4, // 立体测量
        M_Angel: 5, // 角度测量
        M_Area: 6, // 面积测量
        M_WheelBase: 7, // 轴距测量
      }
      _.forEach(removeTags, (removeTag) => {
        if (this.showDialogCom.includes(removeTag)) {
          // 关闭弹框且判断弹框列表是否为空
          this.openDialogList.splice(_.findIndex(this.openDialogList, ['val', removeTag]), 1)
          this.keepAliveList.splice(this.keepAliveList.indexOf(removeTag.val), 1)
          // 如果移除组件中含有剖切相关的,就移除缓存
          if (this.clipCom.includes(removeTag)) {
            this.keepAliveList.splice(this.keepAliveList.indexOf('ClipTool'), 1)
            // 剖切相关 清除剖切状态
            // cancelClip(this.player) // 待处理
          }
          if (!_.isEmpty(this.openDialogList)) {
            this.openBasicDialog(_.last(this.openDialogList))
          } else {
            // 清除弹框状态，菜单栏状态
            this.showBasicDialog = false
            this.currentBasicCom = ''
            this.showBasicComponents = ''
            this.docHeight.minHeight = '30rem'
            this.docHeight.maxHeight = '40rem'
            this.docHeight.isZoom = false
          }
        }
        if (_.keys(measureList).indexOf(removeTag) !== -1) {
          // 测量不在此处处理
        }
      })
    },
    /**
     * @description: 设置tabBar状态
     * @param {*} tag 当前的激活的tag
     * @return {*}
     */

    async setTabBarStatus(tag) {
      // 测量工具集合
      const measureList = {
        M_Line: 1, // 两点测量
        M_Point: 2, // 多点测量
        M_Vertical: 3, // 高度测量
        M_Stereo: 4, // 立体测量
        M_Angel: 5, // 角度测量
        M_Area: 6, // 面积测量
        M_WheelBase: 7, // 轴距测量
      }
      let removeTags = []
      // 获取移除的tags(剔除重复点击的+tag中不能共存的)
      removeTags = _.remove(this.selectBasicList, (item) => {
        return (
          item === tag.val ||
          (tag.unAllowCoexistCom &&
            tag.unAllowCoexistCom.length &&
            tag.unAllowCoexistCom.includes(item))
        )
      })
      const asyncFun = []
      // 在此处处理测量的移除和工具的关闭
      for (let i = 0; i < removeTags.length; i += 1) {
        if (_.keys(measureList).indexOf(removeTags[i]) !== -1) {
          asyncFun.push(
            this.player.Native.Measure.clearMeasure(measureList[removeTags[i]]),
            this.player.Native.Measure.setMeasureType(0)
          )
        }
        if (this.toolTabBar.includes(removeTags[i])) {
          this.activeBasicToolList.splice(this.activeBasicToolList.indexOf(removeTags[i]), 1)
          asyncFun.push(this.player.Native.Tools.setCurrentTool('system.Browse'))
        }
      }
      await Promise.all(asyncFun)
      // 工具的关闭操作
      this.removeTagsStatus(removeTags, removeTags.includes(tag.val))
      // 数组变化子组件未监听到变化，所以重新赋值。
      this.selectBasicList = _.clone(this.selectBasicList)
      // 判断是否为重复点击的tag
      if (!removeTags.includes(tag.val)) {
        // 当前激活的基础工具储存
        if (this.toolTabBar.includes(tag.val)) {
          this.activeBasicToolList.push(tag.val)
        }
        this.selectBasicList.push(tag.val)
        this.activeBasicTag = tag.val
        return true
      }
      this.activeBasicTag = ''
      return false
    },
    /**
     * @description: 模型基础功能
     * @param {*} val ：data => tags中的val属性
     * @param {*} tag ：data => tags中的val属性
     * @return {*}
     */
    async tagsClick(val, tag) {
      console.log(val, tag, 'val0-tag-')
      if (val.includes('pixelRatio')) {
        // 分辨率
        if (val === 'pixelRatio0') {
          return
        }
        if (val === 'pixelRatio') {
          await this.cloudRender.Engine.setPixelRatio(1)
        }
        if (val === 'pixelRatio2') {
          await this.cloudRender.Engine.setPixelRatio(2)
        }
        if (val === 'pixelRatio3') {
          await this.cloudRender.Engine.setPixelRatio(3)
        }
        if (val === 'pixelRatio4') {
          await this.cloudRender.Engine.setPixelRatio(4)
        }
        setTimeout(() => {
          this.$message.success('画质切换成功')
        }, 1500)
        return
      }
      // 不需要激活态的节点
      const unActiveNode = [
        'system.ToolHideModelSpaceSwap', // 空间交换
        'system.ToolHideModel', // 隐藏
        'system.ToolShowModel', // 显示上一个
        'system.ToolShowAll', // 显示所有已隐藏
        'system.PickupCenter', // 居中
        'saveCameraView', // 保存相机视角
        'M_None', // 清除测量
      ]
      // 测量工具集合
      const measureList = {
        M_Line: 1, // 两点测量
        M_Point: 2, // 多点测量
        M_Vertical: 3, // 高度测量
        M_Stereo: 4, // 立体测量
        M_Angel: 5, // 角度测量
        M_Area: 6, // 面积测量
        M_WheelBase: 7, // 轴距测量
      }
      this.lastActiveBasicTag = this.activeBasicTag
      let changeActiveBasicTag
      if (!unActiveNode.includes(tag.val)) {
        /**
         * 激活状态与选中状态的相互切换逻辑
         */
        // 判断当前tag是否在selectList中
        changeActiveBasicTag = await this.setTabBarStatus(tag)
        if (!changeActiveBasicTag) {
          // 关闭
          if (tag.val === 'system.Pickup') {
            // 如果点选操作模式是开启的，那么就需要先关闭它
            await this.player.Native.Tools.setCurrentTool('system.Browse')
          }
          return
        }
      }
      // 不需要激活的功能操作
      if (unActiveNode.includes(tag.val)) {
        if (tag.val === 'saveCameraView') {
          // 保存视角不需要激活
          this.$emit('annotationClick', val)
          return
        }
        // 针对居中操作单独处理
        if (tag.val === 'system.PickupCenter') {
          this.code = this.centerCode
          this.moveCamera(this.code, 'PickupCenter')
          return
        }
        if (tag.val === 'M_None') {
          // 如果是清除按钮
          await this.player.Native.Measure.clearAll()
          return
        }
        this.setModelVisible(tag.val)
        return
      }
      // 需要操作激活按钮打开的操作
      if (!this.activeBasicTag) {
        this.player.Native.Tools.setCurrentTool('system.Browse')
      } else if (this.showDialogCom.includes(this.activeBasicTag)) {
        this.openBasicDialog(tag)
        this.$emit('closeDocRelational')
      } else if (_.keys(measureList).indexOf(tag.val) !== -1) {
        // console.log('打开还是关闭', changeActiveBasicTag)
        await this.player.Native.Measure.setMeasureType(measureList[tag.val])
      } else {
        // 求其他模型下和测量工具集合的交集(存在交集，说明该功能和测量不共存)
        if (tag.unAllowCoexistCom?.length) {
          const measureArr = _.keys(measureList).filter((v) => {
            return tag.unAllowCoexistCom.indexOf(v) > -1
          })
          if (measureArr.length) {
            // 清空测量工具
            await this.player.Native.Measure.clearAll()
            await this.player.Native.Measure.setMeasureType(0)
          }
        }
        // 基础工具
        if (this.toolTabBar.includes(tag.val)) {
          if (
            ['system.walk.first', 'system.walk.third'].includes(tag.val) &&
            !this.physicsSceneUpdated
          ) {
            await this.player.Native.PhysicsMgr.updatePhysicsScene()
            this.physicsSceneUpdated = true
          }
          await this.player.Native.Tools.setCurrentTool(tag.val)
        }
      }
      // 初始化上次选中节点颜色
      // if (this.modelTreeProp.currentNodeItem) { // vk无此接口
      //   this.player.Native.ModelTree.restoreItemColor(this.modelTreeProp.currentNodeItem)
      // }
      if (this.activeBasicTag === 'PreferenceSetting') {
        // 偏好暂不处理
        this.$emit('closeSystemSetting')
      }
      if (
        [
          'imgAnnotation',
          'viewImgAnnotation',
          'saveCameraView',
          'parseModelInfo',
          'print',
        ].includes(val)
      ) {
        this.$emit('annotationClick', val)
      }
    },
    /**
     * @description: 业务tab按钮
     * @param {*}
     * @return {*}
     */
    tagsBusinessClick(val, tag) {
      this.$emit('tagsBusinessClick', tag)
    },
    /**
     * @description: 需要打开弹框的组件
     * @param {*} data
     * @return {*}
     */

    async openBasicDialog(data) {
      let comStatus = false
      // 开启弹框 or新增弹框
      if (_.isEmpty(_.find(this.openDialogList, ['val', data.val]))) {
        this.openDialogList.push({ ...data, expand: true })
        this.keepAliveList.push(data.val)
        // 如果新增的是剖切相关的，则新增缓存
        if (this.clipCom.includes(data.val)) {
          this.keepAliveList.push('ClipTool')
        }
      } else {
        comStatus = true
      }
      // 如果当前激活的状态未在底层列表中，
      if (!_.find(this.basicTabBar, ['val', data.val])) {
        _.forEach(this.basicTabBar, (tag) => {
          if (tag.children) {
            const tagChild = _.find(tag.children, ['val', data.val])
            if (tagChild) {
              tag = resetObjectValue(tag, tagChild)
            }
          }
        })
      }
      this.currentBasicCom = data
      this.showBasicDialog = true
      this.showBasicComponents = data.val
      this.basicHeight = this.showDocComponent ? data.minHeight : data.maxHeight
      if (this.showDocComponent) {
        const val = parseInt('53rem', 10) - parseInt(this.basicHeight, 10)
        this.docHeight.minHeight = `${val}rem`
        this.docHeight.maxHeight = `${val}rem`
        this.docHeight.isZoom = true
      }
      if (!this.showBasicDialog) {
        this.docHeight.minHeight = '30rem'
        this.docHeight.maxHeight = '40rem'
        this.docHeight.isZoom = false
      }
      if (data.val === 'ModelTree') {
        // this.getModelTreeDatas() // 待删除
        // 判断是否有当前是否有选中状态的节点
        const path = await this.player.Native.Node.getSeletedNodes()
        if (!_.isEmpty(path)) {
          const nodeInfo = await this.player.Native.Node.getProperty(path[0], ['code', 'name'])
          // 获取节点的name
          this.modelTreeProp.currentNodeName = nodeInfo.name
        }
      } else if (this.clipCom.includes(data.val)) {
        // this.setClipBox(this.activeBasicTag) // 操作在组件中完成
        this.clipData.clipType = data.val
      }
    },
    /**
     * @description: 模型卸载
     * @param {*}
     * @return {*}
     */
    destroyPlayer() {
      if (this.player) {
        // 清空动画片段
        this.cloudRender.Engine.destroyEngine()
      }
    },
    // 获取模型树数据
    async getModelTreeDatas() {
      // 加载模型完成后获取模型数据
      this.modelTreeProp.treeData = await PlayerUtils.call(
        this.player.Native.ModelTree.getRootItems
      )
      // 删除地球GIS层
      this.modelTreeProp.treeData = _.filter(this.modelTreeProp.treeData, (item) => {
        return item.itemType === modelTreeObj.ITEM_PR || item.itemType === modelTreeObj.ITEM_NODE
      })
      // 构建第一层的name
      _.forEach(this.modelTreeProp.treeData, (result) => {
        let fileNameItem
        switch (result.itemType) {
          case modelTreeObj.ITEM_PR:
            fileNameItem = _.find(this.ModelMapList, ['name', result.ownModel])
            break
          case modelTreeObj.ITEM_NODE:
            // 节点对应的item
            fileNameItem = _.find(this.ModelMapList, ['name', 'tower'])
            break
          default:
            break
        }
        if (fileNameItem) {
          result.name = result.code
            ? `${fileNameItem.fileName}[${result.code}]`
            : fileNameItem.fileName
        }
      })
    },
    /**
     * @description: 杆塔模型或者pr模型公共定位功能
     * @param {*} data
     * @param {*} type 触发的方法
     * @return {*}
     */

    async doLocation(data, type) {
      if (!data) return
      switch (data.itemType) {
        case modelTreeObj.ITEM_PR:
          if (this.$route.query.engineerId) {
            this.$emit('modelClick', data, type)
            return
          }
          data.documentId = _.find(this.ModelMapList, ['name', data.ownModel]).documentId
          this.centerCode = data.code
          // 获取设备详细信息
          this.$emit('modelClick', data, type)
          break
        case modelTreeObj.ITEM_NODE:
          if (this.$route.query.engineerId) {
            this.$emit('modelClick', data, type)
            return
          }
          const fRet = await findTower(data.item)
          if (fRet.item !== 0) {
            // 是杆塔模型或杆塔模型的子节点
            data.code = fRet.code
            // data.documentId = _.find(this.ModelMapList, ['name', 'tower']).documentId
            // 获取设备详细信息
            this.$emit('modelClick', data, type)
            // if (rRet.isChild) {
            //   //是杆塔模型的子节点
            // }else{
            //   //杆塔模型本身
            // }
          } else {
            // 其他的非杆塔模型节点
            console.log('watchMsg error: unknown itemType')
          }
          break
        default:
          console.log('watchMsg error : unknown itemType:', data.iemType)
          break
      }
    },
    // 选中工程节点信息
    handleNodeClick(data) {
      this.$emit('handleNodeClick', data)
    },
    // 控制模型中部件的显示隐藏
    async setModelVisible(status, isChecked = true, selectInfo = {}, checkeds) {
      if (_.isEmpty(selectInfo)) {
        // 获取当前点选的对象
        selectInfo = await this.player.Native.Node.getSeletedNodes()
      }
      const itemList = _.map(this.modelTreeProp.modelHideList, (el) => {
        return el.node
      })
      const rootParent = await this.player.Native.Node.getRoot()
      const rootProperty = await this.player.Native.Node.getProperty(rootParent, ['children'])
      const rootNode = rootProperty.children[0]?.node
      // 删除地球GIS层
      const rootItemsList = [rootNode]
      switch (status) {
        case 'system.ToolShowModel':
          // 显示上一个(影藏模型列表弹出最后一个，隐藏最后一个，默认框选中的列表添加弹出的最后一个)
          if (this.modelTreeProp.modelHideList.length > 0 && !this.spaceSwapStatus) {
            this.player.Native.Node.setProperty(
              this.modelTreeProp.modelHideList[this.modelTreeProp.modelHideList.length - 1].node,
              { visible: isChecked }
            )
            this.modelTreeProp.defaultCheckedKey.push(
              this.modelTreeProp.modelHideList[this.modelTreeProp.modelHideList.length - 1].node
            )
            this.modelTreeProp.filterItem.splice(
              this.modelTreeProp.filterItem.indexOf(
                this.modelTreeProp.modelHideList[this.modelTreeProp.modelHideList.length - 1].node
              ),
              1
            )
            this.modelTreeProp.modelHideList.pop()
          }
          break
        case 'system.ToolShowAll':
          // 显示全部隐藏（根据上面获取的跟节点之间都设置为true，清空隐藏模型列表，默认框选中的列表加上隐藏模型列表）
          this.player.Native.Node.setProperty(rootItemsList, { visible: isChecked })
          // 去重
          this.modelTreeProp.defaultCheckedKey = [
            ...new Set([...this.modelTreeProp.defaultCheckedKey, ...this.modelTreeProp.filterItem]),
          ]
          this.modelTreeProp.filterItem = []
          this.modelTreeProp.modelHideList = []
          this.spaceSwapStatus = false
          break
        case 'system.ToolHideModel':
          // 隐藏选中节点（把当前要隐藏的项添加到隐藏模型列表中，设置当前项隐藏状态，当前项以及其子孙节点都应该从默认框选中列表中除去）
          if (_.last(this.modelTreeProp.filterItem) === selectInfo[0]) return
          this.modelTreeProp.modelHideList.push({ node: selectInfo[0] })
          this.player.Native.Node.setProperty(selectInfo[0], { visible: false })

          this.modelTreeProp.filterItem.push(selectInfo[0])
          // 获取选中的selectInfo的父级selfId
          let parentInfo = await this.player.Native.Node.getProperty(selectInfo[0], ['parent'])
          this.modelTreeProp.filterItem.push(parentInfo.parent)
          // 如果不为最外层包裹层
          if (parentInfo.parent) {
            while (parentInfo.parent !== rootNode) {
              // eslint-disable-next-line no-await-in-loop
              parentInfo = await this.player.Native.Node.getProperty(parentInfo.parent, ['parent'])
              this.modelTreeProp.filterItem.push(parentInfo.node)
            }
          }
          const result = await this.player.Native.Node.getProperty(selectInfo[0], ['children'])
          const subItems = result.children
          // 去重放在报错之后，多push了几次进去
          this.modelTreeProp.filterItem = [
            ...new Set([
              ...this.modelTreeProp.filterItem,
              ..._.map(subItems, (res) => {
                return res.node
              }),
            ]),
          ]
          this.modelTreeProp.defaultCheckedKey = _.filter(
            this.modelTreeProp.defaultCheckedKey,
            (el) => {
              return this.modelTreeProp.filterItem.indexOf(el) === -1
            }
          )
          break
        case 'system.ToolHideModelSpaceSwap':
          // 空间交换
          // 隐藏模型，显示隐藏列表（将默认框选中的列表等于隐藏模型列表，上一次隐藏的全部显示）
          if (this.spaceSwapStatus) {
            this.modelTreeProp.defaultCheckedKey = _.map(this.modelTreeProp.modelHideList, (el) => {
              return el.node
            })
          } else {
            this.hiddenNodeKeys = _.map(this.modelTreeProp.modelHideList, (el) => {
              return el.node
            })
          }
          this.player.Native.Node.setProperty(rootItemsList, { visible: this.spaceSwapStatus })
          this.player.Native.Node.setProperty(itemList, { visible: !this.spaceSwapStatus })
          this.spaceSwapStatus = !this.spaceSwapStatus

          this.modelTreeProp.filterItem = _.filter(this.modelTreeProp.filterItem, (el) => {
            return this.hiddenNodeKeys.indexOf(el) === -1
          })
          this.modelTreeProp.filterItem = [
            ...new Set([...this.modelTreeProp.filterItem, ...this.modelTreeProp.defaultCheckedKey]),
          ]
          ;[this.modelTreeProp.defaultCheckedKey, this.modelTreeProp.hiddenNodeKeys] = [
            this.modelTreeProp.hiddenNodeKeys,
            this.modelTreeProp.defaultCheckedKey,
          ]
          break
        case 'checkModelTree':
          // 模型树显隐操作: 1、根据勾选情况设置当前勾选项的显隐 2、设置默认框选中列表
          // 3、如果是显示: 查找当前项是否在隐藏列表中，如果有就去掉当前项以及其子孙节点，默认框选中列表中需要添加当前项，如果该项的其他兄弟节点都为选中状态，那么其父辈节点也就要添加进去
          // 4、如果是隐藏：将当前项添加到隐藏模型列表中去，默认框选中列表除去当前项以及其子孙节点，还包括其父辈节点
          this.player.Native.Node.setProperty(selectInfo[0], { visible: isChecked })
          this.modelTreeProp.defaultCheckedKey = checkeds.checkedKeys
          if (isChecked) {
            const index = _.findIndex(this.modelTreeProp.modelHideList, ['node', selectInfo[0]])
            if (index !== -1) {
              this.modelTreeProp.modelHideList.splice(index, 1)
            }
            const index1 = this.modelTreeProp.filterItem.indexOf(selectInfo[0])
            if (index1 !== -1) {
              // 重新设置选中
              this.modelTreeProp.filterItem.splice(
                this.modelTreeProp.filterItem.indexOf(selectInfo[0]),
                1
              )
            }
          } else {
            this.modelTreeProp.modelHideList.push({ node: selectInfo[0] })
            this.modelTreeProp.filterItem.push(selectInfo[0])
            // 获取选中的selectInfo的父级selfId
            let ParentInfo = await this.player.Native.Node.getProperty(selectInfo[0], ['parent'])
            this.modelTreeProp.filterItem.push(ParentInfo.parent)
            // 添加父节点到filterItem
            if (!this.modelTreeProp.filterItem.includes(ParentInfo.parent)) {
              this.modelTreeProp.filterItem.push(ParentInfo.parent)
            }

            /**
             * 十个递归九个死循环！！！
             */
            // 必须保证有父节点才进入循环查找父节点
            while (ParentInfo.parent && ParentInfo.parent !== rootNode) {
              ParentInfo = await this.player.Native.Node.getProperty(ParentInfo.parent, ['parent'])
              if (!ParentInfo || !ParentInfo.parent) {
                break
              }

              if (!this.modelTreeProp.filterItem.includes(ParentInfo.parent)) {
                this.modelTreeProp.filterItem.push(ParentInfo.parent)
              }
            }
            this.modelTreeProp.filterItem = [...new Set(this.modelTreeProp.filterItem)]
          }
          break

        default:
          break
      }
    },
    // 剖切功能
    async setClipBox() {
      const playerId = this.modelName || this.modelProps.defaultModelId
      cancelClip(this.player)
      if (!this.activeBasicTag) return
      this.clipData = this.$options.data().clipData
      switch (this.activeBasicTag) {
        case 'AllClip':
          this.clipData = { ...(await cilpSetting(this.player, playerId, false, false, 'box', 4)) }
          break
        case 'PartClipBox':
          this.clipData = { ...(await cilpSetting(this.player, playerId, false, true, 'box', 4)) }
          break
        case 'ThreePanel':
          this.clipData = {
            ...(await cilpSetting(this.player, playerId, true, false, 'ThreePanel', 1)),
          }
          break
        default:
          break
      }
      this.clipData.clipType = this.activeBasicTag
    },
    switchDialog(row) {
      if (row.expand) {
        this.$emit('closeDocRelational')
      }
      console.log(row, 'row-11')
      if (row.val === this.currentBasicCom.val) {
        // 清除弹框状态，菜单栏状态
        this.showBasicDialog = true
        this.currentBasicCom = ''
        this.showBasicComponents = ''
        this.docHeight.minHeight = '30rem'
        this.docHeight.maxHeight = '40rem'
        this.docHeight.isZoom = false
        return
      }

      this.openBasicDialog(row)
    },
    /**
     * @description: 关闭弹框
     * @param {*} val 组件名称
     * @return {*}
     */

    async closeComponents(val) {
      const currentCom = _.find(this.basicTabBar, (res) => {
        if (res.children) {
          const resChild = _.find(res.children, ['val', val])
          if (resChild) {
            res = resetObjectValue(res, resChild)
          }
        }
        return res.val === val
      })
      if (currentCom) {
        this.setTabBarStatus(currentCom)
      }
      if (val === 'PreferenceSetting') {
        const res = await PreferenceSettingApi.getCurrentUserSetting()
        if (res) {
          this.userPreferenceSettings = res?.extraProperties
        }
      }
    },
    tabBarResize: _.debounce(function(id) {
      if (this.businessTabBar && this.businessTabBar.length === 0) return
      const currentIndex = Math.floor(
        document.getElementById(this.businessTabBarId).offsetWidth / 44 || 0
      )
      if (currentIndex === this.businessTabBar.length || currentIndex <= 0) return
      const tempTags = this.businessTabBar.slice(0, currentIndex - 1)
      const hoverTags = this.businessTabBar.slice(currentIndex, this.businessTabBar.length - 1)
      tempTags[currentIndex - 1] = {
        name: '更多',
        val: 'more',
        iconName: 'icon-more',
        unAllowCoexistCom: [],
        hoverWidth: hoverTags.length * 40,
        children: this.businessTabBar.slice(currentIndex, this.businessTabBar.length - 1),
      }
      this.businessTabBarComputed = tempTags
    }, 300),
    // 获取预加载分配节点
    async getDistributeEngine() {
      try {
        const [err, res] = await PreloadService.getEngineId({
          MD5: this.modelParams[0].md5,
          filePath: `data://../apps/${this.currentEnv.VUE_APP_CURRENT_PROJECT}/models/${this.modelParams[0].md5}/${this.modelParams[0].md5}.${this.modelParams[0].type}`,
        })
        if (!err && res?.data?.code === 200 && res.data.data?.engineId) {
          console.log('🚀 预加载， runplayer')
          this.preloadEngineId = res.data.data.engineId
          this.runPlayer()
        } else {
          // 手动
          console.log('🚀 手动加载')
          this.runPlayer()
        }
      } catch (error) {
        console.log('❌ getDistributeEngine error', error)
        // 手动
        console.log('🚀 手动加载')
        this.runPlayer()
      }
    },
    // 强制终止连接
    async forceTerminate(id) {
      if (id) {
        const [err, res] = await PreloadService.forceTerminate({
          id,
          t: new Date().valueOf(),
        })
      }
    },
    currentCodeChange(code) {
      this.$emit('currentCodeChange', code)
    },
  },
  async created() {
    this.playerEngineDomId = this.playerEngineId || 'engineId'
    this.businessTabBarId = `m${this.generateUUID()}`
    this.basicTabBarId = `m${this.generateUUID()}`
    // this.businessTabBarComputed = this.businessTabBar
    this.loadingEngine = true
    if (!_.isEmpty(this.modelParams)) {
      this.$nextTick(() => {
        if (Wiz.globalSettings.globalConfig.modelSetting.preloadServer) {
          this.getDistributeEngine() // 预加载
        } else {
          console.log('🚀 手动加载')
          this.runPlayer(this.modelParams[0].documentId) // 手动
        }
        this.currentFileId = this.modelParams[0].fileId
      })
    }
    this.moduleAuth = await ConfirmAuth('实体文档')
  },
  mounted() {
    // if (this.$route.query.engineerId) {
    //   this.runPlayer(this.$route.query.engineerId)
    // }
    window.addEventListener('beforeunload', async (e) => {
      if (this.preloadEngineId) {
        this.forceTerminate(this.preloadEngineId)
      } else {
        this.destroyPlayer()
      }
    })
  },
  beforeDestroy() {
    this.cloudRender.Dispatch.off('Engine', this.engineMessage)
    if (this.preloadEngineId) {
      this.forceTerminate(this.preloadEngineId)
    } else {
      this.destroyPlayer()
    }
  },
}
</script>
<style lang="scss" scoped>

.engineVideo {
  object-fit: fill;
  // margin-top: -15px;
  height: 100vh;
}
.b-40 {
  bottom: 40px;
}
/deep/.el-loading-mask {
  background-color: #ffffff00 !important;
}
.position-absolute {
  position: absolute;
}
.flex-row-center-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>
